/// <reference path="../_references.js" />


    /*
        Address = 1 (aId)
        Zone = 2 (zId)
        Visit = 3 (vVisitGroupingId)
        Visit Point = 4 (tTrackpointId)
        Trip Point = 5 (tTrackpointId)
    */

   if (isNullOrUndefined(veritracks)) {
    throw ('Mapping.js requires the veritracks namespace defined in Default.js');
}

if (isNullOrUndefined(veritracks.mapping)) {
    veritracks.mapping = {};
}

veritracks.mapping.data = {
    'ExportData': null,
    'ExcelExportData': null,
    'EnumeratedIcons': [],    
};

veritracks.mapping.iconGenerator = new IconGenerator();
veritracks.mapping.enums = {
    "SpeedSlow": "Slow",
    "SpeedMedium": "Medium",
    "SpeedFast": "High"
}


veritracks.mapping.prepareTrackpointMarkerData = function (aDataset) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lResult = [],
        lCounter = 1,
        lMarker,
        lLatitude,
        lLongitude,
        lCount;
  
        
    if (!isNullOrUndefined(aDataset)) {
        lCount = aDataset.length;
    }
    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lResult.push(veritracks.mapping.prepareTrackpointMarkerItem(aDataset[lKey]));
        }
    }
    return lResult;
};

veritracks.mapping.generateTrackpointBits = function (aTrackpoint) {
    "use strict";
    var lBitValue = 0;
    if (gUserDetails && gUserDetails.Role !== 2) {
        if (aTrackpoint.IsInBraceletStrap) {
            lBitValue = lBitValue + 1;
        }
        if (aTrackpoint.IsInLowBattery) {
            lBitValue = lBitValue + 10;
        }
        if (aTrackpoint.IsOnCharger) {
            lBitValue = lBitValue + 100;
        }
        if (aTrackpoint.IsInInclusionZone) {
            lBitValue = lBitValue + 1000;
        }
        if (aTrackpoint.IsInExclusionZone) {
            lBitValue = lBitValue + 10000;
        }
    }
    return lBitValue;
};
/**
 * generate unique file names based on conditions met
 * @param  {} aTrackpoint
 * @param  {} aEnrolleePosition 
 */
veritracks.mapping.generateIconNames = function(aTrackpoint, aEnrolleePosition){
    var lIconName = '',
        lEnrolleePosition = 1, 
        lTrackItem;

    if (aTrackpoint.__type == "Tag:www.veritracks.com"){
        lIconName = lIconName + "Tag-";
    } else {
        lIconName = lIconName + aTrackpoint.TrackTypeId + "-";
    }
    

    if ([1, 3, 8, 9, 12, 14, 25, 33, 31, 61].indexOf(aTrackpoint.TrackTypeId) != -1 || aTrackpoint.__type == "Tag:www.veritracks.com") {
        lTrackItem = aTrackpoint;
    } else {        
        lTrackItem = aTrackpoint.Data;
        if (!isNullOrUndefined(aTrackpoint.Association)) {
            lIconName = lIconName + aTrackpoint.Association.IconId + "";
        }

        if (!isNullOrUndefined(lTrackItem.Duration)) {
            lIconName = lIconName + durationFormatter(lTrackItem.Duration);
        }

        if (!isNullOrUndefined(lTrackItem.Frequency)) {
            lIconName = lIconName + lTrackItem.Frequency + "";
        }
    }
    
    if (!isNullOrUndefined(lTrackItem.SpeedRange)) {        
        lIconName = lIconName + lTrackItem.SpeedRange[0];
        if (lTrackItem.SpeedRange != veritracks.mapping.enums.SpeedSlow && !isNullOrUndefined(lTrackItem.BearingDegree)) {
            if (lTrackItem.BearingDegree >= -22.5 && lTrackItem.BearingDegree < 22.5) {
                lIconName = lIconName + "N";
            } else if (lTrackItem.BearingDegree >= 22.5 && lTrackItem.BearingDegree < 67.5) {
                lIconName = lIconName + "NE";
            } else if (lTrackItem.BearingDegree >= 67.5 && lTrackItem.BearingDegree < 112.5) {
                lIconName = lIconName + "E";
            } else if (lTrackItem.BearingDegree >= 112.5 && lTrackItem.BearingDegree < 157.5) {
                lIconName = lIconName + "SE";
            } else if (lTrackItem.BearingDegree >= 157.5 && lTrackItem.BearingDegree < 180) {
                lIconName = lIconName + "S";
            } else if (lTrackItem.BearingDegree >= -157.5 && lTrackItem.BearingDegree < -112.5) {
                lIconName = lIconName + "SW";
            } else if (lTrackItem.BearingDegree >= -112.5 && lTrackItem.BearingDegree < -67.5) {
                lIconName = lIconName + "W";
            } else {
                lIconName = lIconName + "NW";
            }            
        }        
    } 

    if (!isNullOrUndefined(lTrackItem.IconId)) {
        lIconName = lIconName + lTrackItem.IconId + "";
    }

    if (!isNullOrUndefined(aEnrolleePosition) && !isNaN(aEnrolleePosition)) {
        lIconName = lIconName + "-" + aEnrolleePosition;
    } else {
        lIconName = lIconName + "-" + lEnrolleePosition;
    }

    return lIconName;

}

/**
 * generate unique file names based on event conditions met
 * @param  {} aTrackpoint 
 */
veritracks.mapping.generateEventIconNames = function (aTrackpoint,aEnrolleePosition) {
    var lIconName = veritracks.mapping.generateIconNames(aTrackpoint,aEnrolleePosition);
  

    if (aTrackpoint.TrackTypeId == 12) {
        lIconName = lIconName + 'LT';
    }

    if (aTrackpoint.IsInBraceletStrap) {
        lIconName = lIconName + 'MSTP';
    }
    if (aTrackpoint.IsInExclusionZone) {
        lIconName = lIconName + 'EZ';        
    }
    if (aTrackpoint.IsInInclusionZone) {
        lIconName = lIconName + 'IZ';
    }
    if (aTrackpoint.IsInLowBattery) {
        lIconName = lIconName + 'LB';
    }
    if (aTrackpoint.IsOnCharger) {
        lIconName = lIconName + 'C';
    }

    return lIconName;
}

/**
 * generate raw svg file
 * @param  {} aTrackpoint - trackpoint data
 * @param  {} aSkipSvgGen - skip generation of raw file, only if it is not cached in veritracks.mapping.data.EnumeratedIcons
 * @param  {} aEnrolleePosition - primary enrollee 1 or secondary enrollee 2
 */
veritracks.mapping.prepareRawSvg = function (aTrackpoint, aSkipSvgGen, aEnrolleePosition) {
    var lbindMarkers = [],
        lLabel,
        lIndex,
        lBuilder = new SumoPredicateBuilder(),       
        lVisitIcons = [],
        lFrequencyTextLength = 0,
        lMapScaleSize = null,
        lTrackItem = null;

    if (!veritracks.mapping.iconGenerator.getStatus()) {
        veritracks.mapping.iconGenerator.initialize();
    }

    veritracks.mapping.iconGenerator.clear();
    if (aTrackpoint.__type == "Tag:www.veritracks.com"){
        aTrackpoint.TrackTypeId = 1;
        aTrackpoint.IconId = 21; 
    }
    if ([1, 3, 8, 9, 12, 14, 25, 33, 31,61].indexOf(aTrackpoint.TrackTypeId) != -1) {              
        lTrackItem = aTrackpoint;        
        //wifi,celltower,bh
        if ([3,9,33,31].indexOf(aTrackpoint.TrackTypeId) != -1) {
            lMapScaleSize = new google.maps.Size(25, 25);
        } else {
            lMapScaleSize = new google.maps.Size(55, 55);
        }
        
    } else {
        lTrackItem = aTrackpoint.Data;      
        lMapScaleSize = new google.maps.Size(70, 70);
    }
   
    //second enrollee
    if (!isNullOrUndefined(aEnrolleePosition) && aEnrolleePosition == 2) {
        if ([1, 3, 8, 9, 12, 33].indexOf(aTrackpoint.TrackTypeId) != -1) {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional("IconName", "Second Enrollee TrackPoint", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
            for (var key in lVisitIcons) {
                if (lVisitIcons.hasOwnProperty(key)) {
                    veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                }
            }                           

        } else {           
            if (!isNullOrUndefined(lTrackItem.Association)) {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional("IconName", "Second Enrollee Association", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
                for (var key in lVisitIcons) {
                    if (lVisitIcons.hasOwnProperty(key)) {
                        veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                    }
                }
            } else if (!isNullOrUndefined(lTrackItem.Duration) && durationFormatter(lTrackItem.Duration) == '0M') {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional("IconName", "Second Enrollee Visit In Progress", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
                for (var key in lVisitIcons) {
                    if (lVisitIcons.hasOwnProperty(key)) {
                        veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                    }
                }
            } else {
                lBuilder.Clear();
                lBuilder.AddNewExpressionConditional("IconName", "Second Enrollee Visit", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
                for (var key in lVisitIcons) {
                    if (lVisitIcons.hasOwnProperty(key)) {
                        veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                    }
                }
            }//end fo else            
        }

    } else {
        if (isNullOrUndefined(aSkipSvgGen) || !aSkipSvgGen) {
            //regular icon
            veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[lTrackItem.IconId]);
        }

        //duration, specifically remove the last contact visit and associations           
        if (!isNullOrUndefined(lTrackItem.Duration) && durationFormatter(lTrackItem.Duration) != '0M') {
            //associations
            if (!isNullOrUndefined(lTrackItem.Association)) {
                veritracks.mapping.iconGenerator.addSVGToQueue(mEnrolleesIcon.icons[lTrackItem.Association.IconId]);
            }
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional("IconName", "Duration", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
            for (var key in lVisitIcons) {
                if (lVisitIcons.hasOwnProperty(key)) {
                    lVisitIcons[key].TextOptions = { 'Text': durationFormatter(lTrackItem.Duration), 'Fill': '#FFF', 'Family': 'Helvetica', 'Move': { 'cx': 4, 'cy': 35 } };
                    veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                }
            }
        } else if (!isNullOrUndefined(lTrackItem.Duration) && durationFormatter(lTrackItem.Duration) == '0M') {
            lBuilder.Clear();
            veritracks.mapping.iconGenerator.clear();            
            lBuilder.AddNewExpressionConditional("IconName", "Visit Current", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
            for (var key in lVisitIcons) {
                if (lVisitIcons.hasOwnProperty(key)) {
                    veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                }
            }
        } else if (aTrackpoint.TrackTypeId == 12) {
            lBuilder.Clear();
            veritracks.mapping.iconGenerator.clear();
            lBuilder.AddNewExpressionConditional("IconName", "Last Track", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
            for (var key in lVisitIcons) {
                if (lVisitIcons.hasOwnProperty(key)) {
                    veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                }
            }
        }else if (aTrackpoint.TrackTypeId == 61) {
            lBuilder.Clear();
            veritracks.mapping.iconGenerator.clear();
            lBuilder.AddNewExpressionConditional("Id", aTrackpoint.IconId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
            for (var key in lVisitIcons) {
                if (lVisitIcons.hasOwnProperty(key)) {
                    veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                }
            }
        }


        //visit frequency
        if (!isNullOrUndefined(lTrackItem.Frequency) && lTrackItem.Frequency > 0) {
            lBuilder.Clear();
            lBuilder.AddNewExpressionConditional("IconName", "Frequency", false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lVisitIcons = query(mEnrolleesIcon.icons, lBuilder.RootExpression);
            for (var key in lVisitIcons) {
                if (lVisitIcons.hasOwnProperty(key)) {
                    lFrequencyTextLength = (lTrackItem.Frequency + "").length;
                    if (lFrequencyTextLength > 1) {
                        lFrequencyTextLength = lFrequencyTextLength + 3;
                    }
                    
                    lVisitIcons[key].TextOptions = { 'Text': lTrackItem.Frequency + "", 'Fill': '#FFF', 'Family': 'Helvetica', 'Move': { 'cx': (64 - lFrequencyTextLength), 'cy': 23 }, 'Size':12};
                    veritracks.mapping.iconGenerator.addSVGToQueue(lVisitIcons[key]);
                }
            }
        }
    }   

    lTrackItem.BindMarkers = lbindMarkers;
    lTrackItem.VisitLabels = lLabel
    lTrackItem.CenterX = veritracks.mapping.iconGenerator.getCenterX();
    lTrackItem.CenterY = veritracks.mapping.iconGenerator.getCenterY();
    lTrackItem.ScaledImageSize = lMapScaleSize;
    return lTrackItem;

}

/**
 * get Enrollee Map Card prefix name. Used for selecting a single Card View Element
 * @param  {} aTrackpoint 
 * @param  {} aEnrolleePosition
 */
veritracks.mapping.getMapCardPrefix = function(aTrackpoint, aEnrolleePosition) {
    "use strict";
    var lKey,
        lResult = {},
        lCounter = 1,
        lMarker,
        lClass,
        lLatitude,
        lLongitude,
        lEnrolleePosition = 1,
        lXOffset = 11,
        lYOffset = 11,
        lData = aTrackpoint,
        lCardPrefix = '',
        lContact;
   
    
    if (!isNullOrUndefined(aEnrolleePosition) && typeof aEnrolleePosition==='number' && !isNaN(aEnrolleePosition)) {
        lEnrolleePosition = aEnrolleePosition;
    }

    lClass = 'TrackPoint';
    lMarker = 'Images/Maps/TrackPoint.png';
    lCardPrefix = 'c';    
    switch (aTrackpoint.TrackTypeId) {
        case 1:
            lClass = ((10000000 * lEnrolleePosition) + (100000 * aTrackpoint.TrackTypeId) + veritracks.mapping.generateTrackpointBits(aTrackpoint));
            lContact = gEnrolleeLastContact[aTrackpoint.EnrolleeId];
            if (!isNullOrUndefined(lContact) && lContact.DeviceId === aTrackpoint.DeviceId && lContact.TrackDate.getTime() === aTrackpoint.TrackDate.getTime()) {
                lClass += 1000000;
            }
            lMarker = 'Images/Maps/Trackpoints/' + lClass.toString() + '.png';
            lCardPrefix = 't';
            break;
        case 11:
            // this is probably not possible
            lClass = ((10000000 * lEnrolleePosition) + 100000 + veritracks.mapping.generateTrackpointBits(aTrackpoint)).toString();
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            lCardPrefix = 't';
            break;
        case 2:
        case 3:
            lClass = ((10000000 * lEnrolleePosition) + (100000 * aTrackpoint.TrackTypeId)).toString();
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            lCardPrefix = 't';
			break;
		case 9:
			//this is for wifi icon update (6/21/18)
			lClass = ((10000000 * lEnrolleePosition) + (100000 * aTrackpoint.TrackTypeId)).toString();
			lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
			lCardPrefix = 't';
			break;
        case 4: 
            lXOffset = 8;
            lYOffset = 8;
            lData = aTrackpoint.Data;

            lClass = 10000000 * lEnrolleePosition;
            if (lData.IsCurrent) {
                lClass += 1000000;
            }
            if (lData.HasEvents) {
                lClass += 1;
            }
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lClass = lClass.toString();

            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            lCardPrefix = 'v';
            break;
        case 5:
            // address - home
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 6:
            // address - work
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 7:
            // address - other
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 8:
            // inventory location
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 22:
            //home Tethered
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 23:
            //home Work
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 24:
            //home Other
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 25:
            //bpltbs
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;



        // NON-CALCULATED VALUES
        case 11:
            lMarker = 'Images/Maps/SuggestionDark.png';
            break;
        case 12:
            lMarker = 'Images/Maps/enrolleePoint.png';
            break;
        case 13:
            lMarker = 'Images/Maps/incident.png';
            break;
        case 14:
            lMarker = 'Images/Maps/box_16_light.png';
            break;
        case 15:
            lMarker = 'Images/Maps/Trackpoints/10500000.png';
            break;
        case 16:
            lMarker = 'Images/Maps/Trackpoints/10600000.png';
            break;
        case 17:
            lMarker = 'Images/Maps/Trackpoints/10700000.png';
            break;
        case 18:
            lMarker = 'Images/Maps/incidentRed.png';
            break;
        case 21:
            var lMapAlcoholStatus = liveMapTestStatus(aTrackpoint);            
            lClass = lMapAlcoholStatus[0]
            lMarker = lMapAlcoholStatus[1];
            break;
        case 31: //ema
            lClass = 10900001;
            lMarker = 'Images/Maps/Trackpoints/10900001.png';
            if (mStateManager.Tab() === "Events") {
                lClass = 10900011;
                lMarker = 'Images/Maps/Trackpoints/10900011.png';
            }
            lCardPrefix = 't';
            break;
        case 61: //ema
            lClass = 'TrackPoint'+aTrackpoint.IconId;
            lMarker = 'Images/SAMA-'+aTrackpoint.IconId+'.png'; 
            lCardPrefix = 't';
            break;
        case 33: //BLUHome v4
            lClass = 10900100;
            lMarker = 'Images/Maps/Trackpoints/10900100.png';
            //if (mStateManager.Tab() === "Events") {
            //    lClass = 10900101;
            //    lMarker = 'Images/Maps/Trackpoints/10900101.png';
            //}
            lCardPrefix = 't';
            break;
        default:
            lMarker = 'Images/Maps/Suggestion.png';
            break;
    }
    lLatitude = aTrackpoint.Latitude;
    lLongitude = aTrackpoint.Longitude;
    
    lResult = {
        'data': lData,
        'latitude': lLatitude,
        'longitude': lLongitude,
        'anchor': { 'x': lXOffset, 'y': lYOffset },
        'path': lMarker,
        'doHover': true,
        'cardViewClass': lClass,
        'identity': aTrackpoint.TrackDate
    };
    return {'Data': lData, 'CardPrefix':lCardPrefix};    

}

/**
 * generate google map marker
 * @param  {} aTrackpoint - trackpoint data 
 * @param  {} aEnrolleePosition - primary enrollee 1 or secondary enrollee 2
 * @param  {} aFileMarker - flag to determine if the image will be written to file, default will write to file
 */
veritracks.mapping.prepareTrackpointMarkerItem = function (aTrackpoint, aEnrolleePosition, aFileMarker) {
    var lIndex,
        lResult = {},
        lMarker,
        lMarkerData = null,
        lClass="TrackPoint",
        lLatitude,
        lLongitude,
        lXOffset = 8,
        lYOffset = 8,
        lData = aTrackpoint,
        lEnrollee = null,
        lLabel = null,
        lSvgMarker = null,
        lbindMarkers = [],
        lTrackItem = null,
        lIconName = '',
        lIconUrl = '',
        lWriteToFile = true,
        lCardPrefix = null,
        lIsInformatics = false;

    lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees');
    if(mStateManager.IsSystemState('Layout','Victims')){
        lEnrollee = getDataItem(mEnrolleesData.VictimCurrentId, 'Enrollees');
    }
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        mEnrolleesData.EnableInformatics = { 'OrganizationId': lEnrollee.OrganizationId, 'IsEnabled': lIsInformatics };
    } else {
        mEnrolleesData.EnableInformatics = { 'OrganizationId': -1, 'IsEnabled': false };
    }
    
   // && 
    if (lIsInformatics) {
        if (!isNullOrUndefined(aFileMarker)) {
            lWriteToFile = aFileMarker;
        }
        lIndex = veritracks.mapping.generateIconNames(aTrackpoint, aEnrolleePosition);
        lYOffset = 30;
        lXOffset = 25;
        if (typeof veritracks.mapping.data.EnumeratedIcons[lIndex] == 'undefined' || [1, 3, 8, 9, 12, 33,31,61].indexOf(aTrackpoint.TrackTypeId) == -1) {
            lTrackItem = veritracks.mapping.prepareRawSvg(aTrackpoint, false, aEnrolleePosition);
            lbindMarkers = lTrackItem.BindMarkers;
            lLabel = lTrackItem.VisitLabels;
            if (veritracks.mapping.iconGenerator.drawSVG()) {

                if (lLabel != null) {
                    veritracks.mapping.iconGenerator.addText(lLabel, {
                        family: 'Helvetica',
                        size: 5,
                        anchor: 'middle',
                        leading: '1.5em'
                    });
                }
                //get generated svg
                var mSvgMarker = veritracks.mapping.iconGenerator.getSvg();               
                lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mSvgMarker);
                lSvgMarker = { 'SVGMarker': mSvgMarker, 'BearingDegree': lTrackItem.BearingDegree, 'CenterX': lTrackItem.CenterX, 'CenterY': lTrackItem.CenterY };
                veritracks.mapping.data.EnumeratedIcons[lIndex] = { 'SVGMarker': mSvgMarker, 'BearingDegree': lTrackItem.BearingDegree, 'CenterX': lTrackItem.CenterX, 'CenterY': lTrackItem.CenterY, 'FileMarker': lWriteToFile };
            }
        } else {
            lTrackItem = veritracks.mapping.prepareRawSvg(aTrackpoint, true, aEnrolleePosition);
            lbindMarkers = lTrackItem.BindMarkers;
            lLabel = lTrackItem.VisitLabels;
            if (lLabel != null) {
                veritracks.mapping.iconGenerator.addText(lLabel, {
                    family: 'Helvetica',
                    size: 5,
                    anchor: 'middle',
                    leading: '1.5em'
                });
            }
            //get generated svg
            lSvgMarker = veritracks.mapping.data.EnumeratedIcons[lIndex];
            lMarker = veritracks.mapping.iconGenerator.generateMapMarker(lSvgMarker.SVGMarker);
        }


        lLatitude = lTrackItem.Latitude;
        lLongitude = lTrackItem.Longitude;
        lCardPrefix = veritracks.mapping.getMapCardPrefix(lData, aEnrolleePosition);
        lMarkerData = lCardPrefix.Data
        lMarkerData.cardViewPrefix = lCardPrefix.CardPrefix;
        if (!lWriteToFile) {
            lIconUrl = lMarker;
            
        } else {
            lIconUrl = VERITRACKS_WEB_LOCAL + veritracks.system.clientSetting("svgimagespath") + lIndex + ".png"
        }
        lResult = {
            'data': lMarkerData,
            'latitude': lLatitude,
            'longitude': lLongitude,
            'anchor': { 'x': lXOffset, 'y': lYOffset },
            'iconUri': lIconUrl,
            'doHover': true,
            'cardViewClass': lClass,
            'label': lLabel,
            'centerX': veritracks.mapping.iconGenerator.getCenterX(),
            'centerY': veritracks.mapping.iconGenerator.getCenterY(),
            'degreeRotation': lSvgMarker.BearingDegree,
            'index': lIndex,
            'bindMarkers': lbindMarkers,
            'SVGMarker': lSvgMarker.SVGMarker,
            'identity': lTrackItem.TrackDate,
            'ScaledImageSize': lTrackItem.ScaledImageSize
        };
        veritracks.mapping.iconGenerator.clear();

        return lResult;
    } else {
        //use old icons
        return veritracks.mapping.prepareTrackpointMarkerItem_dep(aTrackpoint, aEnrolleePosition)
    }
       
    
}
veritracks.mapping.preparePointOfInterestShapeItem = function(PoiItemObject){
    var lKey,
        lShapeType,
        lColor,
        lResult = {};

    // Circular = 1
    // Polygonal = 2
    if (!isNullOrUndefined(PoiItemObject)) {
        
        lShapeType = PoiItemObject.Shape !== 2 ? 'circle':'polygon';
        var colors ={
            2:"#e3004f",
            1:"#00e37d"
        }
        var radiusColor = PoiItemObject.Id === -1 ? '#acacac': colors[PoiItemObject.Type] ;
        lResult = {
            'type': lShapeType,
            'id': PoiItemObject.Id,
            'centerLatitude': PoiItemObject.CenterLatitude,
            'centerLongitude': PoiItemObject.CenterLongitude,
            'radius': sumo.geo.conversion.feetToMeters(PoiItemObject.Radius),
            'vertices': PoiItemObject.vertices,
            'isEditable': PoiItemObject.Id === -1 ? true : false,
            'fillColor': radiusColor,
            'fillOpacity': 0.30,
            'strokeColor': radiusColor,
            'strokeOpacity': 0.65,
            'strokeWeight': 2,
            // 'text': 'hello',
            // 'data': PoiItemObject
        };
    }
    return lResult;
}
veritracks.mapping.preparePointOfInterestMarkerItem = function(PoiItemObject){
    // 
    var lBuilder = new SumoPredicateBuilder(),
        lPoiIcon = null,
        lIcons = [],
        lMarker;
    var POI_AOI = 2,markerOptions = {1:"Label",2:"AOI"};
    var iconName = markerOptions[PoiItemObject.Type];// === POI_AOI ? "AOI" : "Label";

    veritracks.mapping.iconGenerator.clear();    
    var IconId = IconHelper.getIconIdByName(iconName);
    if(!isNullOrUndefined(mEnrolleesIcon['icons'][IconId]['IconValue'])){
        lMarker = veritracks.mapping.iconGenerator.generateMapMarker(mEnrolleesIcon.icons[IconId]['IconValue'])
    }
    return  {
        'data': PoiItemObject,
        'latitude': PoiItemObject.CenterLatitude,
        'longitude': PoiItemObject.CenterLongitude,
        'anchor': { 'x': 0, 'y': 35 },
        'doHover': false,
        'iconUri': lMarker,
        'SVGMarker': lMarker,
    };
}

veritracks.mapping.preparePointOfInterestMarkerData =function (aDataset) {
    "use strict";
    var lKey,
        lResult = [];   
    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lResult.push(veritracks.mapping.preparePointOfInterestMarkerItem(aDataset[lKey]));
        }
    }
    return lResult;
};
veritracks.mapping.preparePointOfInterestShapeData = function (aDataset) {
    "use strict";
    var lKey,
        lResult = [];
    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lResult.push(veritracks.mapping.preparePointOfInterestShapeItem(aDataset[lKey]));
        }
    }
    return lResult;
};

//deprecated
veritracks.mapping.prepareTrackpointMarkerItem_dep = function (aTrackpoint, aEnrolleePosition) {
    "use strict";
    var lKey,
        lResult = {},
        lCounter = 1,
        lMarker,
        lClass,
        lLatitude,
        lLongitude,
        lEnrolleePosition = 1,
        lXOffset = 11,
        lYOffset = 11,
        lData = aTrackpoint,
        lContact;
   
    if (!isNullOrUndefined(aEnrolleePosition) && typeof aEnrolleePosition==='number') {
        lEnrolleePosition = aEnrolleePosition;
    }

    lClass = 'TrackPoint';
    lMarker = 'Images/Maps/TrackPoint.png';
    aTrackpoint.cardViewPrefix = 'c';    
    switch (aTrackpoint.TrackTypeId) {
        case 1:
            lClass = ((10000000 * lEnrolleePosition) + (100000 * aTrackpoint.TrackTypeId) + veritracks.mapping.generateTrackpointBits(aTrackpoint));
            lContact = gEnrolleeLastContact[aTrackpoint.EnrolleeId];
            if (!isNullOrUndefined(lContact) && lContact.DeviceId === aTrackpoint.DeviceId && lContact.TrackDate.getTime() === aTrackpoint.TrackDate.getTime()) {
                lClass += 1000000;
            }
            lMarker = 'Images/Maps/Trackpoints/' + lClass.toString() + '.png';
            aTrackpoint.cardViewPrefix = 't';
            break;
        case 11:
            // this is probably not possible
            lClass = ((10000000 * lEnrolleePosition) + 100000 + veritracks.mapping.generateTrackpointBits(aTrackpoint)).toString();
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            aTrackpoint.cardViewPrefix = 't';
            break;
        case 2:
        case 3:
            lClass = ((10000000 * lEnrolleePosition) + (100000 * aTrackpoint.TrackTypeId)).toString();
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            aTrackpoint.cardViewPrefix = 't';
			break;
		case 9:
			//this is for wifi icon update (6/21/18)
			lClass = ((10000000 * lEnrolleePosition) + (100000 * aTrackpoint.TrackTypeId)).toString();
			lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
			aTrackpoint.cardViewPrefix = 't';
			break;
        case 4: 
            lXOffset = 8;
            lYOffset = 8;
            lData = aTrackpoint.Data;

            lClass = 10000000 * lEnrolleePosition;
            if (lData.IsCurrent) {
                lClass += 1000000;
            }
            if (lData.HasEvents) {
                lClass += 1;
            }
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lClass = lClass.toString();

            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            lData.cardViewPrefix = 'v';
            break;
        case 5:
            // address - home
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 6:
            // address - work
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 7:
            // address - other
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 8:
            // inventory location
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 22:
            //home Tethered
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 23:
            //home Work
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 24:
            //home Other
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;
        case 25:
            //bpltbs
            lClass = 10000000 * lEnrolleePosition;
            lClass += (100000 * aTrackpoint.TrackTypeId);
            lMarker = 'Images/Maps/Trackpoints/' + lClass + '.png';
            break;



        // NON-CALCULATED VALUES
        case 11:
            lMarker = 'Images/Maps/SuggestionDark.png';
            break;
        case 12:
            lMarker = 'Images/Maps/enrolleePoint.png';
            break;
        case 13:
            lMarker = 'Images/Maps/incident.png';
            break;
        case 14:
            lMarker = 'Images/Maps/box_16_light.png';
            break;
        case 15:
            lMarker = 'Images/Maps/Trackpoints/10500000.png';
            break;
        case 16:
            lMarker = 'Images/Maps/Trackpoints/10600000.png';
            break;
        case 17:
            lMarker = 'Images/Maps/Trackpoints/10700000.png';
            break;
        case 18:
            lMarker = 'Images/Maps/incidentRed.png';
            break;
        case 21:
            var lMapAlcoholStatus = liveMapTestStatus(aTrackpoint);            
            lClass = lMapAlcoholStatus[0]
            lMarker = lMapAlcoholStatus[1];
            break;
        case 31: //ema
            lClass = 10900001;
            lMarker = 'Images/Maps/Trackpoints/10900001.png';
            if (mStateManager.Tab() === "Events") {
                lClass = 10900011;
                lMarker = 'Images/Maps/Trackpoints/10900011.png';
            }
            aTrackpoint.cardViewPrefix = 't';
            break;
        case 33: //BLUHome v4
            lClass = 10900100;
            lMarker = 'Images/Maps/Trackpoints/10900100.png';
            //if (mStateManager.Tab() === "Events") {
            //    lClass = 10900101;
            //    lMarker = 'Images/Maps/Trackpoints/10900101.png';
            //}
            aTrackpoint.cardViewPrefix = 't';
            break;
        case 61: //SAMA
            lClass = 'TrackPoint'+aTrackpoint.IconId;
            lMarker = 'Images/SAMA-'+aTrackpoint.IconId+'.png'; 
            aTrackpoint.cardViewPrefix = 't';
            break;
        default:
            lMarker = 'Images/Maps/Suggestion.png';
            break;
    }
    lLatitude = aTrackpoint.Latitude;
    lLongitude = aTrackpoint.Longitude;
    
    lResult = {
        'data': lData,
        'latitude': lLatitude,
        'longitude': lLongitude,
        'anchor': { 'x': lXOffset, 'y': lYOffset },
        'iconUri': lMarker,
        'doHover': true,
        'cardViewClass': lClass,
        'identity': aTrackpoint.TrackDate
    };

    return lResult;
};

veritracks.mapping.prepareAddressItem = function (aAddress, aEnrolleePosition) {
    "use strict";
    var lResult;
    
    if (aAddress.Latitude !== 0 || aAddress.Longitude !== 0) {
        if (aAddress.AddressTypeId === 1 && aAddress.TetheredLocationFlag == false) {
            lResult = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 5, 'Latitude': aAddress.Latitude, 'Longitude': aAddress.Longitude, 'TrackDate': new Date(), 'Data': aAddress }, aEnrolleePosition);
        } else if (aAddress.AddressTypeId === 2 && aAddress.TetheredLocationFlag == false) {
            lResult = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 6, 'Latitude': aAddress.Latitude, 'Longitude': aAddress.Longitude, 'TrackDate': new Date(), 'Data': aAddress }, aEnrolleePosition);
        } else if (aAddress.TetheredLocationFlag == false) {
            lResult = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 7, 'Latitude': aAddress.Latitude, 'Longitude': aAddress.Longitude, 'TrackDate': new Date(), 'Data': aAddress }, aEnrolleePosition);
        } else if (aAddress.AddressTypeId === 1 && aAddress.TetheredLocationFlag == true) {
            lResult = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 22, 'Latitude': aAddress.Latitude, 'Longitude': aAddress.Longitude, 'TrackDate': new Date(), 'Data': aAddress }, aEnrolleePosition);
        } else if (aAddress.AddressTypeId === 2 && aAddress.TetheredLocationFlag == true) {
            lResult = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 23, 'Latitude': aAddress.Latitude, 'Longitude': aAddress.Longitude, 'TrackDate': new Date(), 'Data': aAddress }, aEnrolleePosition);
        } else {
            lResult = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 24, 'Latitude': aAddress.Latitude, 'Longitude': aAddress.Longitude, 'TrackDate': new Date(), 'Data': aAddress }, aEnrolleePosition);
        }
    }
    return lResult;
};


veritracks.mapping.getAlchoholTestEvents = function (aEnrolleeId, aEnrolleePosition, aScheduleId, aStopDate, aOnSuccess, aOnFail, aParams) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lRequestId = aParams[0],
        lTrackData = aParams[1],
        lScheduleStopDate = aStopDate,
        lNewTrackData = []; 

    lBuilder.AddNewExpressionConditional("EnrolleeId", aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("ScheduleId", aScheduleId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderAlcoholSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, onAlcoholSchedule_OnSuccess, aOnFail, null, null, 0);

    function onAlcoholSchedule_OnSuccess(aParams, aData) {
        var lDataIds = [-1],
            lImageBuilder = new SumoPredicateBuilder();

        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                lDataIds.push(aData[key].ImageId);
            }
        }

        lImageBuilder.AddNewExpressionConditional("ImageId", lDataIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lImageBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        ReadMultiple(gObjectList.OffenderAlcoholImage.AssemblyQualifiedName, lImageBuilder.RootExpression, 0, onAlchoholTest_OnLoad, aOnFail, aData, null, 0);
    }

    function onAlchoholTest_OnLoad(aParams, aData) {
        "use strict";
        var lCardList = [],
        lStartDate = null,
        lStopDate = null,
        lTimeZone = null,
        lMatches = [],
        lTrackItem = null,
        lCardType = null,
        lLat = 0,
        lLng = 0,
        lImageBuilder = new SumoPredicateBuilder(),
        lImages = [],
        lImagesSelect = null,
        lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
        lCard = new MapCard(),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;

        if (!isNullOrUndefined(lEnrollee)) {
            lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        }
       
        FixDates(aParams);

        for (var Datakey in aParams) {
            if (aParams.hasOwnProperty(Datakey)) {
                lLat = aParams[Datakey].Latitude;
                lLng = aParams[Datakey].Longitude;

                lStartDate = aParams[Datakey].StartDate;
                lStopDate = lScheduleStopDate;
                lTimeZone = getEnrolleeTimeZone(aParams[Datakey].EnrolleeId),

                lImageBuilder.Clear();
                lImageBuilder.AddNewExpressionConditional('ImageId', aParams[Datakey].ImageId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                lImages = query(aData, lImageBuilder.RootExpression);
                lImagesSelect = null;
                for (var ikey in lImages) {
                    if (lImages.hasOwnProperty(ikey)) {
                        lImagesSelect = lImages[ikey];
                    }
                }

                lCardType = 21;
               
                lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': lCardType, 'Latitude': lLat, 'Longitude': lLng, 'TrackDate': lStartDate, 'Data': aParams[Datakey], 'ImageData': lImagesSelect, 'StatusId': aParams[Datakey].StatusId, 'EnrolleeId': aParams[Datakey].EnrolleeId, 'NumberRetest': aParams[Datakey].NumberRetest }, aEnrolleePosition);

                if (!isNullOrUndefined(lTrackItem)) {
                    lCard = new MapCard();
                    lCard.Type = lCardType;
                    lCard.Id = 'al' + aParams[Datakey].Id;
                    lCard.SortOrder = 4;
                    lCard.EnrolleeId = aParams[Datakey].EnrolleeId;
                    lCard.GsmSignalStrength = -1;
                    lCard.ViewPanoramaSetting = 'StreetViewIcon';
                    lCard.Name = aParams[Datakey].Name;
                    lCard.EnrolleeFirstName = lEnrollee.FirstName;
                    lCard.EnrolleeLastName = lEnrollee.LastName;
                    lCard.EnrolleeName = lEnrollee.FullName;
                    lCard.Date = DisplayShortDateTime(displayFixedTimeZoneTime(lStartDate, lTimeZone.TimeZoneName));
                    lCard.Detail = 'Start: ' + DisplayShortDateTime(displayFixedTimeZoneTime(lStartDate, lTimeZone.TimeZoneName));
                    lCard.Detail2 = 'End: ' + DisplayShortDateTime(displayFixedTimeZoneTime(lStopDate, lTimeZone.TimeZoneName));
                    lCard.Latitude = lLat;
                    lCard.Longitude = lLng;
                    lCard.SortDate = lStartDate;
                    lCard.TrackItem = lTrackItem;
                    lCard.IconClass = lTrackItem.cardViewClass;
                    lCard.SVGMarker = lTrackItem.SVGMarker;
                    if (lIsInformatics) {
                        lCard.SVGDisplay = 'block';
                        lCard.MarkerSingleIcon = 'table-row-group';
                        lCard.iconUri = lTrackItem.iconUri;
                    }
                    
                    lNewTrackData.push(lCard);
                }


            }
        }
        aOnSuccess(lRequestId, lTrackData, lNewTrackData);
    }

}

veritracks.mapping.getAlchoholTestCardItems = function (aEnrolleeId, aEnrolleePosition, aStartTime, aEndTime, aOnSuccess, aOnFail) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();

    var lStart = moment(aStartTime).add(getOffsetOfSaveDate(), 'minutes'),
        lEnd = moment(aEndTime).add(getOffsetOfSaveDate(), 'minutes');

    function onAlcoholSchedule_OnSuccess(aParams, aData) {
        var lDataIds = [-1],
            lImageBuilder = new SumoPredicateBuilder();

        for (var key in aData) {
            if (aData.hasOwnProperty(key)) {
                lDataIds.push(aData[key].ImageId);
            }
        }//end of for

        lImageBuilder.AddNewExpressionConditional("ImageId", lDataIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        lImageBuilder.AddNewExpressionConditional("IsActive", true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lImageBuilder.AddNewExpressionConditional('StartDate', lStart, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lImageBuilder.AddNewExpressionConditional('StopDate', lEnd, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());

        ReadMultiple(gObjectList.OffenderAlcoholImage.AssemblyQualifiedName, lImageBuilder.RootExpression, 0, onAlchoholTest_OnLoad, aOnFail, aData, null, 0);
    }
        

    function onAlchoholTest_OnLoad(aParams, aData) {
        var lCardList = [],
            lStartDate = null,
            lStopDate = null,
            lTimeZone = null,
            lMatches = [],
            lTrackItem = null,
            lCardType = null,
            lLat = 0,
            lLng = 0,
            lImageBuilder = new SumoPredicateBuilder(),
            lImages = [],
            lImagesSelect = null,
            lEnrollee = getDataItem(aEnrolleeId, 'Enrollees'),
            lCard = new MapCard(),
            lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
            lIsInformatics = false;

        if (!isNullOrUndefined(lEnrollee)) {
            lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        }
            
            FixDates(aParams);

            for (var Datakey in aParams) {
                if (aParams.hasOwnProperty(Datakey)) {
                        lLat = aParams[Datakey].Latitude;
                        lLng = aParams[Datakey].Longitude;

                        lStartDate = aParams[Datakey].StartDate;
                        lStopDate = aParams[Datakey].StopDate;
                        lTimeZone = getEnrolleeTimeZone(aParams[Datakey].EnrolleeId),
                   
                        lImageBuilder.Clear();
                        lImageBuilder.AddNewExpressionConditional('ImageId', aParams[Datakey].ImageId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
                        lImages = query(aData, lImageBuilder.RootExpression);
                        lImagesSelect = null;
                        for (var ikey in lImages){
                            if (lImages.hasOwnProperty(ikey)) {
                                lImagesSelect = lImages[ikey];
                            }
                        }
                  
                        lCardType = 21;  

                        lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': lCardType, 'Latitude': lLat, 'Longitude': lLng, 'TrackDate': lStartDate, 'Data': aParams[Datakey], 'ImageData': lImagesSelect, 'StatusId': aParams[Datakey].StatusId, 'EnrolleeId': aParams[Datakey].EnrolleeId, 'NumberRetest': aParams[Datakey].NumberRetest }, aEnrolleePosition);

                        if (!isNullOrUndefined(lTrackItem)) {
                            lCard = new MapCard();
                            lCard.Type = lCardType;
                            lCard.Id = 'al' + aParams[Datakey].Id;
                            lCard.SortOrder = 4;
                            lCard.EnrolleeId = aParams[Datakey].EnrolleeId;
                            lCard.GsmSignalStrength = -1;
                            lCard.ViewPanoramaSetting = 'StreetViewIcon';
                            lCard.Name = aParams[Datakey].Name;
                            lCard.EnrolleeFirstName = lEnrollee.FirstName;
                            lCard.EnrolleeLastName = lEnrollee.LastName;
                            lCard.EnrolleeName = lEnrollee.FullName;
                            lCard.Date = DisplayShortDateTime(displayFixedTimeZoneTime(lStartDate, lTimeZone.TimeZoneName));
                            lCard.Detail = 'Start: ' + DisplayShortDateTime(displayFixedTimeZoneTime(lStartDate, lTimeZone.TimeZoneName));
                            lCard.Detail2 = 'End: ' + DisplayShortDateTime(displayFixedTimeZoneTime(lStopDate, lTimeZone.TimeZoneName));
                            lCard.Latitude = lLat;
                            lCard.Longitude = lLng;
                            lCard.SortDate = lStartDate;
                            lCard.TrackItem = lTrackItem;
                            lCard.IconClass = lTrackItem.cardViewClass;
                            lCard.SVGMarker = lTrackItem.SVGMarker;
                            if (lIsInformatics) {
                                lCard.SVGDisplay = 'block';
                                lCard.MarkerSingleIcon = 'table-row-group';
                                lCard.iconUri = lTrackItem.iconUri;
                            }
                            lCardList.push(lCard);
                        }
                    }//end of inner if  
               // }//end of if       
            }//end of for
        aOnSuccess(lCardList);
    }//end of function
       
    lBuilder.AddNewExpressionConditional("EnrolleeId", aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("StartDate", lStart, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());

    lBuilder.AddNewExpressionConditional("StopDate", lEnd, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional("IsActive", 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    ReadMultiple(gObjectList.OffenderAlcoholSchedule.AssemblyQualifiedName, lBuilder.RootExpression, 0, onAlcoholSchedule_OnSuccess, aOnFail, null, null, 0);

};


veritracks.mapping.prepareVisitItem = function (aVisit, aEnrolleePosition, aAssociation) {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
   
    if (lIsInformatics) {
        //ongoing visit will have iconId 0
        if (aVisit.IconId == 0) {
            aVisit.IconId = 1;
        }

        if (!isNullOrUndefined(aAssociation)) {
            aVisit.Association = aAssociation;
        }
        return veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 4, 'Latitude': aVisit.Latitude, 'Longitude': aVisit.Longitude, 'TrackDate': aVisit.StartDate, 'Data': aVisit, "Association": aAssociation }, aEnrolleePosition, false);
    } else {
        return veritracks.mapping.prepareTrackpointMarkerItem_dep({ 'TrackTypeId': 4, 'Latitude': aVisit.Latitude, 'Longitude': aVisit.Longitude, 'TrackDate': aVisit.StartDate, 'Data': aVisit }, aEnrolleePosition);
    }    
    
};


// LAST CONTACT DISPLAY
veritracks.mapping.prepareContactMarkerData = function (aDataset, aMarkerType) {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
   
    var lKey,
        lResult = [],
        lCounter = 1,
        lMarker,
        lLatitude,
        lLongitude,
        lMarkerType = 1;

    if (!isNullOrUndefined(aMarkerType)) {
        lMarkerType = aMarkerType;
    }
 
    if (!isNullOrUndefined(aDataset)) {
        for (lKey in aDataset) {
            if (aDataset.hasOwnProperty(lKey)) {
                if (lIsInformatics) {
                    lResult.push(veritracks.mapping.prepareTrackpointMarkerItem(aDataset[lKey], lMarkerType));
                } else {
                    lResult.push(veritracks.mapping.prepareTrackpointMarkerItem_dep(aDataset[lKey], lMarkerType));
                }                
            }
        }
    }
    return lResult;
};

//veritracks.mapping.prepareContactMarkerItem = function (aTrackpoint) {
//    "use strict";
//    return veritracks.mapping.prepareTrackpointMarkerItem(aTrackpoint, 1);
    //return veritracks.mapping.prepareTrackpointMarkerItem({ 'TrackTypeId': 11, 'Latitude': aTrackpoint.Latitude, 'Longitude': aTrackpoint.Longitude, 'TrackDate': aTrackpoint.TrackDate, 'Data': aTrackpoint }, aEnrolleePosition, 1);

    //var lKey,
    //    lResult = {},
    //    lCounter = 1,
    //    lMarker,
    //    lLatitude,
    //    lLongitude;

    //lMarker = 'Images/Maps/TrackPoint.png';
    //switch (aTrackpoint.TrackTypeId) {
    //    case 1:
    //        lMarker = 'Images/Maps/TrackPoint.png';
    //        break;
    //    case 2:
    //        lMarker = 'Images/Maps/CellTrack.png';
    //        break;
    //    case 3:
    //        lMarker = 'Images/Maps/tower.png';
    //        break;
    //    case 4:
    //        lMarker = 'Images/Maps/enrolleePoint.png';
    //        break;
    //    default:
    //        lMarker = 'Images/Maps/Suggestion.png';
    //        break;
    //}
    //lLatitude = aTrackpoint.Latitude;
    //lLongitude = aTrackpoint.Longitude;

    //aTrackpoint.cardViewPrefix = 'c';

    //lResult = {
    //    'data': aTrackpoint,
    //    'latitude': lLatitude,
    //    'longitude': lLongitude,
    //    'anchor': { 'x': 8, 'y': 8 },
    //    'iconUri': lMarker,
    //    'doHover': true
    //};

    //return lResult;
//};

veritracks.mapping.prepareTrackpointLineSegmentData = function (aDataset) {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);

    }
       // [latitude, longitude], hoverText, data - sort order matters
    var lKey,
        lLastItem = null,
        lCurrentItem = null,
        lResult = [];

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lCurrentItem = aDataset[lKey];           
            if (lLastItem !== null) {
                lResult.push({
                    'begin': { 'latitude': lLastItem.Latitude, 'longitude': lLastItem.Longitude },
                    'end': { 'latitude': lCurrentItem.Latitude, 'longitude': lCurrentItem.Longitude },
                    'data': { 'begin': lLastItem, 'end': lCurrentItem },
                    // doHover, hoverHtml, hoverCssClass, hoverVerticalOffset, hoverHorizontalOffset
                    //'hoverHtml': 'from ' + DisplayShortDateTime(lLastItem.TrackDate) + '<br/> to ' + DisplayShortDateTime(lCurrentItem.TrackDate),
                    'hoverHtml': 'from ' + DisplayShortDateTime(lLastItem.TrackDate) + '\n to ' + DisplayShortDateTime(lCurrentItem.TrackDate),
                    'doHover': true,
                    'hoverCssClass': 'HoverLabel',
                    'hoverVerticalOffset': -5,
                    'hoverHorizontalOffset': -5,
                    'StrokeColor':'red'                   
                });
            }
            lLastItem = lCurrentItem;
        }
    }
    return lResult;

};

veritracks.mapping.prepareTripPointLineSegmentData = function (aDataset) {
    "use strict";
    var lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);

    }
       // [latitude, longitude], hoverText, data - sort order matters
    var lKey,
        lLastItem = null,
        lCurrentItem = null,
        lTrackDateDiff,
        lStrokeWidth = 2,
        lVerticalOffset = -8,
        lStrokeColorList = {},
        lResult = [];

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lCurrentItem = aDataset[lKey];           
            if (lLastItem !== null) {
                if (lIsInformatics) {
                    if(!isNullOrUndefined(lCurrentItem.data)){
                        lTrackDateDiff = Math.abs(lCurrentItem.data.TrackDate - lLastItem.data.TrackDate);
                        if (lTrackDateDiff / 36000 <= 3) {
                            lStrokeColorList = 'green';
                        } else if (lTrackDateDiff / 36000 <= 10) {
                            lStrokeColorList = 'yellow';
                        } else {
                            lStrokeColorList = 'red';
                        }
                    }
                    lStrokeWidth = 15;
                    lVerticalOffset = -10;
                } else {
                    lStrokeWidth = 2;
                    lStrokeColorList = 'red';
                }
               
                lResult.push({
                    'begin': { 'latitude': lLastItem.latitude, 'longitude': lLastItem.longitude },
                    'end': { 'latitude': lCurrentItem.latitude, 'longitude': lCurrentItem.longitude },
                    'data': { 'begin': lLastItem, 'end': lCurrentItem },
                    // doHover, hoverHtml, hoverCssClass, hoverVerticalOffset, hoverHorizontalOffset
                    //'hoverHtml': 'from ' + DisplayShortDateTime(lLastItem.TrackDate) + '<br/> to ' + DisplayShortDateTime(lCurrentItem.TrackDate),
                    //'hoverHtml': 'from ' + DisplayShortDateTime(lLastItem.TrackDate) + '\n to ' + DisplayShortDateTime(lCurrentItem.TrackDate),
                    'hoverHtml': 'text',
                    'doHover': true,
                    'hoverCssClass': 'HoverLabel',
                    'hoverVerticalOffset': -5,
                    'hoverHorizontalOffset': -5,
                    'horizontalOffset': -10,
                    'verticalOffset': lVerticalOffset,
                    'strokeWeight': lStrokeWidth,
                    'StrokeColor':lStrokeColorList
                   // 'strokeColor': lStrokeColorList
                });
            }
            lLastItem = lCurrentItem;
        }
    }
    return lResult;
};

veritracks.mapping.prepareTrackpointDetailCardLabelOverlayData = function (aCardList, aType) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lHorizontalOffset,
        lVerticalOffset,
        lValue,
        lType = aType,
        lResult = [];


    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aCardList) {
        if (aCardList.hasOwnProperty(lKey)) {
            lDataItem = aCardList[lKey];
            lHorizontalOffset = 4;
            lVerticalOffset = -4;
            lValue = lDataItem.DisplayName.match(/\(([^)]+)\)/);
            lValue = lValue[1];
            
            if (!isNullOrUndefined(lType)) {
                if (lValue.indexOf('V') !== -1) {
                    lHorizontalOffset = 17;
                    lVerticalOffset = 0;
                } else if (lValue.indexOf('CTP') !== -1) {
                    lHorizontalOffset = 17;
                    lVerticalOffset = 0;
                } else if (EnrolleesCheckTrackPointEvents(lDataItem)) {
                    if (lType.indexOf('20') !== -1) {
                        lHorizontalOffset = 8;
                    } else {
                        lHorizontalOffset = 4;
                    }
                }
            }
            else {
                lHorizontalOffset = 12;
            }
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.Latitude,
                'longitude': lDataItem.Longitude,
                'text': lValue,
                'horizontalOffset': lHorizontalOffset,
                'verticalOffset': lVerticalOffset,
                'cssClass': 'TrackLabel'
            });
        }
    }
    return lResult;
};


veritracks.mapping.preparePlacesData = function (aPlaceList) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [];

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aPlaceList) {
        if (aPlaceList.hasOwnProperty(lKey)) {
            lDataItem = aPlaceList[lKey];
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.geometry.location.lat(),
                'longitude': lDataItem.geometry.location.lng(),
                'text': lDataItem.name,
                'cssClass': 'TrackPoint',
                'iconUri': lDataItem.icon,
                'anchor': { 'x': 18, 'y': 18 }
            });
        }
    }
    return lResult;
};

veritracks.mapping.prepareDistanceMarkerData = function (aDistancePoints) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [];

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDistancePoints) {
        if (aDistancePoints.hasOwnProperty(lKey)) {
            lDataItem = aDistancePoints[lKey];
            lResult.push({
               // 'data': null,
                'latitude': lDataItem.latitude,
                'longitude': lDataItem.longitude,
                //'text': null,
                'cssClass': 'TrackPoint',
                'iconUri': 'http://maps.gstatic.com/mapfiles/place_api/icons/geocode-71.png',
                'anchor': { 'x': 18, 'y': 18 }
            });
        }
    }
    return lResult;
};



veritracks.mapping.prepareDistanceLabelOverlayData = function (aDataset) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [],
        lIndex = 1,
        lCssClass = 'NumericLabel',
        lLength = aDataset.length.toString();

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lDataItem = aDataset[lKey];
            lResult.push({
                //'data': lDataItem,
                'latitude': lDataItem.latitude,
                'longitude': lDataItem.longitude,
                'text': lDataItem.text,
                'horizontalOffset': -10,
                'verticalOffset': -8,
                'cssClass': lCssClass
            });
            lIndex++;
        }
    }
    return lResult;
};


veritracks.mapping.prepareNumericLabelOverlayData = function (aDataset) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [],
        lIndex = 1,
        lLength = aDataset.length.toString();

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lDataItem = aDataset[lKey];
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.Latitude,
                'longitude': lDataItem.Longitude,
                'text': lIndex.toString() + ' of ' + lLength,
                'horizontalOffset': -10,
                'verticalOffset': -8,
                'cssClass': 'NumericLabel'
            });
            lIndex++;
        }
    }
    return lResult;
};

veritracks.mapping.prepareSuggestionLabelOverlayData = function (aDataset, aCssClass, aOffsets) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lCssClass = 'NumericLabel',
        lVerticalOffset = -15,
        lHorizontalOffset = -15,
        lResult = [];

    if (aOffsets) {
        lVerticalOffset = aOffsets.VerticalOffset;
        lHorizontalOffset = aOffsets.HorizontalOffset;
    }

    if (!isNullOrUndefined(aCssClass)) {
        lCssClass = aCssClass;
    }
    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lDataItem = aDataset[lKey];
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.Latitude,
                'longitude': lDataItem.Longitude,
                'text': lDataItem.Name,
                'horizontalOffset': lHorizontalOffset,
                'verticalOffset': lVerticalOffset,
                'cssClass': lCssClass
            });
        }
    }
    return lResult;
};


veritracks.mapping.prepareSuggestionLabelOverlayDataSelected = function (aDataset) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [];

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lDataItem = aDataset[lKey];
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.Latitude,
                'longitude': lDataItem.Longitude,
                'text': lDataItem.Name,
                'horizontalOffset': -15,
                'verticalOffset': -15,
                'cssClass': 'SelectedLabel'
            });
        }
    }
    return lResult;
};



veritracks.mapping.prepareZoneLabelOverlayData = function (aDataset) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [];

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lDataItem = aDataset[lKey];
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.Latitude,
                'longitude': lDataItem.Longitude,
                'text': lDataItem.Name,
                'horizontalOffset': -15,
                'verticalOffset': -15,
                'cssClass': 'ZoneLabel'
            });
        }
    }
    return lResult;
};


veritracks.mapping.prepareEnrolleesZoneLabelOverlayData = function (aDataset) {
    "use strict";

    //latitude, longitude, iconUri, hoverText, data
    var lKey,
        lDataItem,
        lResult = [];

    //  index, length, cssClass, latitude, longitude, data, hoverText, map

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lDataItem = aDataset[lKey].data;
            lResult.push({
                'data': lDataItem,
                'latitude': lDataItem.CenterLatitude,
                'longitude': lDataItem.CenterLongitude,
                'text': lDataItem.Name,
                'horizontalOffset': -15,
                'verticalOffset': -15,
                'cssClass': 'ZoneLabel'
            });
        }
    }
    return lResult;
};

veritracks.mapping.prepareEnrolleeHomeAddressOverlayData = function (aDataSet) {
    "use strict";
    var lKey,
        lItem,
        lResult = [];

    for (lKey in aDataSet) {
        if (aDataSet.hasOwnProperty(lKey)) {
            lItem = aDataSet[lKey];
            lResult.push({
                'latitude': lItem.latitude,
                'longitude': lItem.longitude,
                'cssClass': 'TrackPoint',
                'iconUri': 'Images/Maps/Trackpoints/10500000.png', 
                'anchor': { 'x': 18, 'y': 18 }
            });
        }
    }//end of for

    return lResult;
};

veritracks.mapping.placesMarkerInfoClear = function () {
    "use strict";

    $('#uPlacesInfoWindow').animate({ 'z-index': '-2' }, 300);
    $('#uPlacesInfoWindow').animate({ 'bottom': '10apx' }, 200);
};

veritracks.mapping.placesDetailGenerator = function (aNotificationPanel, aMarker) {
    "use strict";
    var lHtml = [],
        lPoint = aMarker.sumoData;

    aNotificationPanel.clearNotifications();

    lHtml.push('<h3>');
    lHtml.push(lPoint.name);
    lHtml.push('</h3>');
    lHtml.push('<div>');
    lHtml.push(lPoint.formatted_address);
    lHtml.push('</div>');
    lHtml.push('<div>');
    lHtml.push('Latitude: ' + lPoint.geometry.location.lat().toString().substring(0, 10));
    lHtml.push('</div>');
    lHtml.push('<div>');
    lHtml.push('Longitude: '+ lPoint.geometry.location.lng().toString().substring(0, 10));
    lHtml.push('</div>');
    lHtml.push('');
    lHtml.push('');
    aNotificationPanel.addNotification(lHtml.join(''), true);

};

veritracks.mapping.placesMarkerClick = function (aSender, aMouseEvent) {
    "use strict";
    var lData = [],
        lPoint = aSender.sumoData,
        lPosition = $('#uMapPanel').position(),
        lMapHeight = $('#uMapPanel').height(),
        lWindowHeight = $(window).height(),
        lBottom = lWindowHeight - (lPosition.top + lMapHeight);

    if ($('#uPlacesInfoWindow').length > 0) {
        $('#uPlacesInfoWindow').html('');

        lData.push('<div id="uPlacesCloseInfoButton" onclick="veritracks.mapping.placesMarkerInfoClear();"></div>');
        lData.push('<table id="uPlacesInfoWindowTable">');
        lData.push('<tr>');
        lData.push('<td>');
        lData.push('Name:');
        lData.push('</td>');
        lData.push('<td>');
        lData.push(lPoint.name);
        lData.push('</td>');
        lData.push('</tr>');
        lData.push('<tr>');
        lData.push('<td>');
        lData.push('Address:');
        lData.push('</td>');
        lData.push('<td>');
        lData.push(lPoint.formatted_address);
        lData.push('</td>');
        lData.push('</tr>');
        lData.push('</table>');

        $('#uPlacesInfoWindow').html(lData.join(''));
        $('#uPlacesInfoWindow').animate({ 'z-index': '5' }, 200);
        $('#uPlacesInfoWindow').animate({ 'bottom': +lBottom + 'px' }, 400);
        //$('#uPlacesInfoWindow').html(lData.join(''));
        if (!$('#uPlacesInfoWindow').is(":visible")) {
            $('#uPlacesInfoWindow').show();
        }
    } else {

        veritracks.mapping.placesDetailGenerator(mEnrolleesControls.NotificationPanel, aSender);

        //mEnrolleesControls.NotificationPanel.clearNotifications();

        //lData.push('<h3>');
        //lData.push(lPoint.name);
        //lData.push('</h3>');
        //lData.push('<div>');
        //lData.push(lPoint.formatted_address);
        //lData.push('</div>');
        //lData.push('');
        //lData.push('');
        //mEnrolleesControls.NotificationPanel.addNotification(lData.join(''), true);
    }


    //aSender.getMap().sumoData.showInfo(aSender, lData.join(''), aMouseEvent.latLng.lat(), aMouseEvent.latLng.lng());
};


veritracks.mapping.generateLegend = function (aNotificationPanel) {
    "use strict";
    var lHtml = [];

    if (!$('.MapLegendTable').is(":visible")) {
        aNotificationPanel.clearNotifications();
        var styleInformatics = 'margin-left:14%',
             lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),             
             isInformatics = false;
        if (!isNullOrUndefined(lEnrollee)) {
            isInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
        
        }
        
        if(isInformatics){
            styleInformatics = '';
        }
        lHtml = [
        '<table style="float:left;" class="MapLegendTable">'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon CorrelationIconProperty ',isInformatics ? 'informatics__icon informatics__icon__association': '','"></div>',
                    '',
                '</td>'
                ,'<td>' + localizeText('cEventHasAssociation') + '</td>'
            ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon CorrelationKnownLocationIconProperty ',isInformatics ? 'informatics__icon informatics__icon__association_known':'' ,'"></div></td>'
            ,'<td>' + localizeText('cEventHasAssociationKnownLocation') + '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10100001IconProperty ',isInformatics ? 'informatics__icon informatics__icon__mastertemper':'','"></div></td>'
            ,'<td>' + localizeText('cEventBraceletStrap') + '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10100010IconProperty ',isInformatics ? 'informatics__icon informatics__icon__lowbattery':'' ,'"></div></td>'
            ,'<td>' + localizeText('cEventLowBattery') + '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10100100IconProperty ',isInformatics ? 'informatics__icon informatics__icon__charging':'','"></div></td>'
            ,'<td>' + localizeText('cEventOnCharger') + '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10101000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__inclusion':'','"></div></td>'
            ,'<td>' , localizeText('cZoneInclusionZone'), '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10110000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__exclusion':'','"></div></td>'
            ,'<td>' + localizeText('cZoneExclusionZone') + '</td>'
        ,'</tr>'
        ,'<tr>'
        ,'<td><div class="MapLegendIcon Track10300000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__celltower':'','"></div></td>'
		,'<td>' + localizeText('cEnrolleesMappingCellTower') + '</td>'
		,'</tr>'
		,'<tr>'
		    ,'<td><div class="MapLegendIcon Track10900000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__wifi':'','"></div></td>'
		    ,'<td>' + localizeText('cEnrolleesMappingWiFi') + '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10900001IconProperty ',isInformatics ? 'informatics__icon informatics__icon__enrollink':'','"></div></td>'
            ,'<td>' + localizeText('cEnrolleesMappingEMACheckIn') + '</td>'
        ,'</tr>'
        ,'<tr>'
            ,'<td><div class="MapLegendIcon Track10900100IconProperty ',isInformatics ? 'informatics__icon informatics__icon__bluehome':'','"></div></td>'
            ,'<td>' + localizeText('cEnrolleeBluHomeV4') + '</td>'
        ,'</tr>'
        ,'</table>'
        ,'<table style="float:left;',styleInformatics,'" class="MapLegendTable">'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track10400000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__map_visit':'','','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesMappingVisit') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track11400000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__inprogress':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesMappingInProgress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track10100000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__trackpoint':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesMappingGPSTrack') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track10500000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__address__home':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesHomeAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track10600000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__address__work':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesWorkAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track10700000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__address__other':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesOtherAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track10700000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__address__transient':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesTransientAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track12200000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__address__homeauth':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesTetheredHomeAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track12300000IconProperty ',isInformatics ? 'informatics__icon informatics__icon__address__workauth':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesTetheredWorkAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track12400000IconProperty ',isInformatics? 'informatics__icon informatics__icon__address__otherauth':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesTetheredOtherAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon Track12400000IconProperty ',isInformatics? 'informatics__icon informatics__icon__address__transientauth':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleesTetheredTransientAddress') + '</td>'
            ,'</tr>'
            ,'<tr>'
                ,'<td><div class="MapLegendIcon SoberTrackIconProperty ',isInformatics ? 'informatics__icon informatics__icon informatics__icon__address__sobertrack':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleeAlcoholTestPoints') + '</td>'
            ,'</tr>',
            ,'<tr>'
                ,'<td><div class="MapLegendIcon SoberTrackIconProperty ',isInformatics ? 'informatics__icon informatics__icon informatics__icon__address__frequent_visit':'','"></div></td>'
                ,'<td>' + localizeText('cEnrolleeFrequentVisits') + '</td>'
            ,'</tr>'
        ,'</table>'];


        if ($('#enrolleesSmallMapCharting').is(':visible')) {
            lHtml.push('<table class="MapLegendTable">');
            for (var lKey in mChartingCalendarColors) {
                if (mChartingCalendarColors.hasOwnProperty(lKey)) {
                    if (lKey.indexOf('In Progress') == -1) {
                        lHtml.push('<tr>');
                        lHtml.push('<td>');
                        lHtml.push(LegendIconDisplay(null, lKey, mChartingCalendarColors[lKey]));
                        lHtml.push('</td>');
                        lHtml.push('</tr>');
                    }
                }
            }
            lHtml.push('</table>');
        }
        aNotificationPanel.addNotification(lHtml.join(''), true);
    }
};


veritracks.mapping.trackPointMarkerClick = function (aSender, aMouseEvent) {
    "use strict";

    var lData = [],
        lPoint = aSender.sumoData;

    //    Public Property BatteryLevel As Integer = 0
    //    Public Property DeviceId As Long = -1
    //    Public Property CellTowerLatitude As Double = 0
    //    Public Property CellTowerLongitude As Double = 0
    //    Public Property TrackTypeId As Long = -1
    //    Public Property HDOP As Integer = 0
    //    Public Property EHPE As Integer = 0
    //    Public Property EVPE As Integer = 0
    //    Public Property GsmSignal As Integer = 0
    //    Public Property SatelliteInView As Integer = 0
    //    Public Property SatelliteUsed As Integer = 0
    //    Public Property IsRfDeviceInRange As RfDeviceInRangeEnum = RfDeviceInRangeEnum.Undefined
    //    Public Property BluDeviceId As Long = -1
    //    Public Property IsInBraceletStrap As Boolean = False
    //    Public Property IsInLowBattery As Boolean = False
    //    Public Property IsOnCharger As Boolean = False
    //    Public Property IsInInclusionZone As Boolean = False
    //    Public Property IsInExclusionZone As Boolean = False

    lData.push('<table cellpadding="2" cellspacing="0" border="0">');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Point Id');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(lPoint.Id);
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Time');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(DisplayShortDateTime(lPoint.TrackDate));
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Latitude');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(lPoint.Latitude);
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Longitude');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(lPoint.Longitude);
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Speed');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(lPoint.Speed);
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Direction');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(DeviceDirectionFormatter(lPoint.Direction));
    lData.push('</td>');
    lData.push('</tr>');
    //lData.push('<tr>');
    //lData.push('<td>');
    //lData.push('Altitude');
    //lData.push('</td>');
    //lData.push('<td>');
    //lData.push(lPoint.Altitude);
    //lData.push('</td>');
    //lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Satellites Used');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(lPoint.SatelliteUsed);
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('<tr>');
    lData.push('<td>');
    lData.push('Battery Voltage');
    lData.push('</td>');
    lData.push('<td>');
    lData.push(DisplayVolts(lPoint.BatteryVoltage));
    lData.push('</td>');
    lData.push('</tr>');
    lData.push('</table>');

    //aAnchor, aHtmlContent, aLatitude, aLongitude
    aSender.getMap().sumoData.showInfo(aSender, lData.join(''), aMouseEvent.latLng.lat(), aMouseEvent.latLng.lng());
};

veritracks.mapping.mapLocate_Complete = function (aType, aLocation) {
    "use strict";

    if (aType === 'Geocode') {
        mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringAddress') + aLocation.formated_address);
    } else {
        mActivityNotification.addNotification(localizeWrapper('cDefaultCenteringLatLong') + aLocation.center_latitude + ', ' + aLocation.center_longitude);
    }
};

veritracks.mapping.uMapLocateButton_OnClick = function () {
    "use strict";
    //mActivityNotification.addNotification('Locate on map.', false);
    var lLocateText = $.trim($('#uMapLocateText').val()),
        lTab = mStateManager.Tab();
    if (lLocateText !== '') {
        switch (mStateManager.Tab()) {
            case 'Enrollees':
                //uEnrolleesMapLocateButton_OnClick(lLocateText);
                mEnrolleesControls.EnrolleesMap.locatePlaces(lLocateText, veritracks.mapping.mapLocate_Complete);
                break;
            case 'Events':
                //uEventsMapLocateButton_OnClick(lLocateText);
                mEventsControls.Map.locatePlaces(lLocateText, veritracks.mapping.mapLocate_Complete);
                break;
            case 'Zones':
                //uZonesMapLocateButton_OnClick(lLocateText);
                mZonesControls.Map.locatePlaces(lLocateText, veritracks.mapping.mapLocate_Complete);
                break;
            case 'Analysis':
                //uAnalysisMapLocateButton_OnClick(lLocateText);
                mAnalysisControls.Map.locatePlaces(lLocateText, veritracks.mapping.mapLocate_Complete);
                break;
        }
    }
};

veritracks.mapping.uMapLocateClearButton_OnClick = function () {
    "use strict";    
        switch (mStateManager.Tab()) {
            case 'Enrollees':
                mEnrolleesControls.EnrolleesMap.layerSetDataSource('Places', veritracks.mapping.preparePlacesData([]));
                break;
            case 'Events':
                mEventsControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData([]));
                break;
            case 'Zones':
                mZonesControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData([]));
                break;
            case 'Analysis':
                mAnalysisControls.Map.layerSetDataSource('Places', veritracks.mapping.preparePlacesData([]));
                break;
    }
        $('#uMapLocateText').val('');
};


// begin show visit points
//veritracks.mapping.tripVisit_ShowPointsSuccess = function (aParams, aData) {
//    "use strict";
//    FixDates(aData);
//    mEnrolleesControls.EnrolleesMap.layerSetDataSource('VisitPoints', veritracks.mapping.prepareTrackpointMarkerData(aData));
//};

//veritracks.mapping.tripVisit_ShowPointsFailure = function (aParams, a, b, c) {
//    "use strict";
//    alert('veritracks.mapping.tripVisit_ShowPointsFailure: ' + b);
//};

//veritracks.mapping.tripVisit_ShowPoints = function (aVisit) {
//    "use strict";
//    var lBuilder = new SumoPredicateBuilder(),
//        lSort = new SortExpression(),
//        lTwoDaysAgo = new Date();
//    lTwoDaysAgo.addDays(-3);

//    if (aVisit.TrackPointCount < 1440) {
//        lBuilder.AddNewExpressionConditional('TrackDate', new Date(aVisit.StartDate).toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
//        lBuilder.AddNewExpressionConditional('TrackDate', new Date(aVisit.EndDate).toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
//        lBuilder.AddNewExpressionConditional('DeviceId', aVisit.DeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
//        lSort.addAscendingColumn('TrackDate');
//        //        if (new Date(aVisit.StartDate) > lTwoDaysAgo) {
//        //            ReadMultiple(gObjectList.Trackpoint.AssemblyQualifiedName, lBuilder.RootExpression, 0, veritracks.mapping.tripVisit_ShowPointsSuccess, veritracks.mapping.tripVisit_ShowPointsFailure, aVisit, lSort, 0);
//        //        } else {
//        ReadMultiple(gObjectList.TrackpointHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, veritracks.mapping.tripVisit_ShowPointsSuccess, veritracks.mapping.tripVisit_ShowPointsFailure, aVisit, lSort, 0);
//        //        }
//    } else {
//        alert('Too many trackpoints to display.');
//    }
//};

veritracks.mapping.generateCardDetailProperty = function (aProperty, aValue) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div class="Ellipsis MapProperty Property">');
    lHtml.push(aProperty);
    lHtml.push(': ');
    lHtml.push(aValue);

    lHtml.push('</div>');

    return lHtml.join('');
};


veritracks.mapping.generateCardDetailSecondProperty = function (aValue) {
    "use strict";
    var lHtml = [];

    lHtml.push('<div class="Ellipsis MapProperty Property">');
    lHtml.push('<strong>');
    lHtml.push(aValue);
    lHtml.push('</strong>');
    lHtml.push('</div>');

    return lHtml.join('');
}

veritracks.mapping.trackpointGenerateCardEventDetail = function (aTrackpoint, aHrefLocation) {
    "use strict";
    var lHtml = [],
    lEventCounter = 0;

    lHtml.push('<div class="PropertyTitle">' + localizeWrapper('cEnrolleeOpenEvents')+' </div> ');
    if (aTrackpoint.IsInBraceletStrap) {
        lEventCounter++;
        lHtml.push('<div class="NoIconProperty">' + localizeWrapper('cEventStrapTamper') + '</div>');
    }
    if (aTrackpoint.IsInLowBattery) {
        lEventCounter++;
        lHtml.push('<div class="NoIconProperty">' + localizeWrapper('cEventLowBattery') + '</div>');
    }
    if (aTrackpoint.IsOnCharger) {
        lEventCounter++;
        lHtml.push('<div class="NoIconProperty">' + localizeWrapper('cEventOnCharger') + '</div>');
    }
    if (aTrackpoint.IsInInclusionZone) {
        lEventCounter++;
        lHtml.push('<div class="NoIconProperty">' + localizeWrapper('cEventInclusionZone') + '</div>');
    }
    if (aTrackpoint.IsInExclusionZone) {
        lEventCounter++;
        lHtml.push('<div class="NoIconProperty">' + localizeWrapper('cEventExclusionZone') + '</div>');
    }
    if (lEventCounter === 0) {
        lHtml.push('<div class="NoIconProperty">' + localizeWrapper('cEventNone') + '</div>');
    }

    if (lEventCounter) {
        if (mStateManager.Tab() == "Enrollees") {
            lHtml.push('<img id="uOffenderGenericEventsIcon" src="Images/Maps/Cards/EventsLight16.png" title='+localizeTitleFormatter('view events')+' class="EnrolleeEvents" onclick="enrolleeMapEventsPopup_Onclick();" />');

        }

    }

    return lHtml.join('');

};

veritracks.mapping.trackpointEvents = function (aTrackpoint) {
    "use strict";
    var lTrackpoint = aTrackpoint,
        lEventCounter = 0, 
        lHasEvents = false;
    
    if (lTrackpoint.IsInBraceletStrap) {
        lEventCounter++;
    }
    if (lTrackpoint.IsInLowBattery) {
        lEventCounter++;
    }
    if (lTrackpoint.IsOnCharger) {
        lEventCounter++;
    }
    if (lTrackpoint.IsInInclusionZone) {
        lEventCounter++;
    }
    if (lTrackpoint.IsInExclusionZone) {
        lEventCounter++;
    }

    if (lEventCounter) {
        lHasEvents = true;
    }

    return lHasEvents;

}

veritracks.mapping.visitTrackpointEvents = function (aPointGroupingItem) {
    "use strict";
    var lPointGroupingItem = aPointGroupingItem,
        lPointKey,
        lPointItem,
        lHasMapEvents = false;

    for (lPointKey in lPointGroupingItem.Trackpoints) {
        if (lPointGroupingItem.Trackpoints.hasOwnProperty(lPointKey)) {
            lPointItem = lPointGroupingItem.Trackpoints[lPointKey];
            //has events on visit or trackpoint
            lHasMapEvents = veritracks.mapping.trackpointEvents(lPointItem);
            if (lHasMapEvents) {
                return lHasMapEvents; 
            }
        }
    }

    if (lPointGroupingItem.Trackpoints.length == 0) {
        lHasMapEvents = true;
    }

    return lHasMapEvents; 
}

veritracks.mapping.hasEventsConfirmed = function (aVisit, aCard) {
    "use strict";
    var lEnrollee = GetEnrollee(aVisit.EnrolleeId);
    var lBuilder = new SumoPredicateBuilder();
    var lChildBuilder = new SumoPredicateBuilder(); 
    var lSort = new SortExpression();
    var lEvents = [];
    var lHasEventstoConfirm = false; 

    var lStartDate = getMoment(aVisit.TrackItem.data.StartDateUTC);
        //lStartDate = getMoment(lStartDate);
        //lStartDate = displayEventInEnrolleeTimeZone(lStartDate, lEnrollee);
    var lStopDate = getMoment(aVisit.TrackItem.data.EndDateUTC);
      //  lStopDate = getMoment(lStopDate);
    var lInProgress = aVisit.TrackItem.data.IsCurrent;

    //if in progress
    if (!isNullOrUndefined(lInProgress)) {
        if (lInProgress) {
            lStopDate = new Date();
        }
    }

 //   var lStopDate = displayEventInEnrolleeTimeZone(lStopDate, lEnrollee);
    
    lBuilder.AddNewExpressionConditional('EnrolleeId', lEnrollee.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('StartDateUTC', lStopDate, false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('IsConfirmed', false, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('DisplayFlag', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lChildBuilder.AddNewExpressionConditional('StopDateUTC', lStartDate, false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.Or());
    lChildBuilder.AddNewExpressionConditional('IsOpen', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.Or());

    lBuilder.Concatenate(lChildBuilder, mLogicalOperatorEnum.And());

    //ReadMultiple(gObjectList.EventHistory.AssemblyQualifiedName, lBuilder.RootExpression, 0, eventConfirm_OnSuccess, null, null, null, 0, true);
    var events = getDataItems('Events');
    var results = query(events, lBuilder.RootExpression);

    if (results && results.length > 0) {
        lHasEventstoConfirm = true;
    }
    
    return lHasEventstoConfirm; 

}


veritracks.mapping.trackpointGenerateCardDetail = function (aTrackpoint) {
    "use strict";
    var lHtml = [],
        lEventCounter = 0;
	
	//this will show the mac address if it is provided. since there is two address coming in from the database this will display the second one only if the first one is null
	if (aTrackpoint.TrackTypeId === 9) {
		if (aTrackpoint.MACAddress !== "null") {
			lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cMacAddress'), aTrackpoint.MACAddress));
		} else if (aTrackpoint.MACAddress2 !== "null") {
			lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cMacAddress'), aTrackpoint.MACAddress2));
		}
	}

    //    Public Property TrackTypeId As Long = -1
    //    Public Property BluDeviceId As Long = -1
    //    Public Property IsRfDeviceInRange As RfDeviceInRangeEnum = RfDeviceInRangeEnum.Undefined
    lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cEnrolleeSpeed'), DisplaySpeed(aTrackpoint.Speed)));
    //lHtml.push(veritracks.mapping.generateCardDetailProperty('Direction', DeviceDirectionFormatter(aTrackpoint.Direction)));
    //lHtml.push(veritracks.mapping.generateCardDetailProperty('Altitude', aTrackpoint.Altitude));
    lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cInventoryBatteryVoltage'), DisplayVolts(aTrackpoint.BatteryVoltage)));
    lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cInventoryHDOP'), aTrackpoint.HDOP));
    //lHtml.push(veritracks.mapping.generateCardDetailProperty('EHPE', aTrackpoint.EHPE));
    //lHtml.push(veritracks.mapping.generateCardDetailProperty('EVPE', aTrackpoint.EVPE));
    //lHtml.push(veritracks.mapping.generateCardDetailProperty('GSM Signal', aTrackpoint.GsmSignal));
    lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cSatellitesInView'), aTrackpoint.SatelliteInView));
    lHtml.push(veritracks.mapping.generateCardDetailProperty(localizeWrapper('cSatellitesUsed'), aTrackpoint.SatelliteUsed));
    //lHtml.push(veritracks.mapping.trackpointGenerateCardEventDetail(aTrackpoint));
    if (gUserDetails.Role !== 2) {
        lHtml.push(veritracks.mapping.trackpointGenerateCardEventDetail(aTrackpoint));
    }
    return lHtml.join('');
};

//veritracks.mapping.visitExpandTrackpoints_OnRender = function (aSender, aParams, aData) {
//    "use strict";
//    mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('databind', veritracks.mapping.visitExpandTrackpoints_OnRender);
//};

veritracks.mapping.visitExpandTrackpoints_OnSuccess = function (aParams, aData) {
    "use strict";
    var //lSort = new SortExpression(),
        lCard = new MapCard(),
        lTempList = [],
        lData,
        lTrackItem,
        lTrackpoint,
        lLength = aData.length,
        lCount = 0,
        lSelection,
        lKey,
        lBuilder = new SumoPredicateBuilder(),
        lEnrollee = getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees'),
        lIsInformatics = false;

    if (!isNullOrUndefined(lEnrollee)) {
        lIsInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
    }
        
    FixDates(aData);
    //setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewHolder', false);

    mActivityNotification.addNotification(aData.length.toString() + ' trackpoints found.');    
    //lSort.addDescendingColumn('TrackDate');
    //lData = lSort.sort(aData);

    for (lCount = 0; lCount < lLength; lCount++) {
        lTrackpoint = lData[lCount];
        lTrackItem = veritracks.mapping.prepareTrackpointMarkerItem(lTrackpoint);
        mEnrolleesData.OffenderMapOverlayDirty.push(lTrackItem);

        lCard = new MapCard();
        lCard.Id = 't' + lTrackpoint.Id;
        lCard.Type = 4;
        lCard.SortOrder = 3;
        lCard.TrackItem = lTrackItem;
        lCard.Name = 'Visit Point ' + (lCount + 1).toString() + ' of ' + lLength.toString();
        lCard.IconClass = 'Track' + lTrackItem.cardViewClass;
        lCard.Date = lTrackpoint.TrackDate;
        lCard.SortDate = lTrackpoint.TrackDate;
        lCard.SVGMarker = lTrackItem.SVGMarker;
        if (lIsInformatics) {
            lCard.SVGDisplay = 'block';
            lCard.MarkerSingleIcon = 'table-row-group';
        }
        switch (lTrackpoint.TrackTypeId) {
            case 1:
            case 2:
                lCard.Latitude = lTrackpoint.Latitude;
                lCard.Longitude = lTrackpoint.Longitude;
                break;
            case 3:
                lCard.Latitude = lTrackpoint.CellTowerLatitude;
                lCard.Longitude = lTrackpoint.CellTowerLongitude;
				break;
			case 9: 
				lCard.Latitude = lTrackpoint.Latitude;
				lCard.Longitude = lTrackpoint.Longitude;
                break;
            case 31:
                lCard.Latitude = lTrackpoint.Latitude;
                lCard.Longitude = lTrackpoint.Longitude;
                break;
            case 32:
                lCard.Latitude = lTrackpoint.Latitude;
                lCard.Longitude = lTrackpoint.Longitude;
                break;
            case 33:
                lCard.Latitude = lTrackpoint.Latitude;
                lCard.Longitude = lTrackpoint.Longitude;
                break;
            case 61:
                lCard.Latitude = lTrackpoint.Latitude;
                lCard.Longitude = lTrackpoint.Longitude;
                break;

        }
        lCard.Address = aParams.Card.Address;
        lCard.IsGeocoded = true;
        lCard.IsExpanded = true;
        lCard.Detail = DisplayShortDateTime(lTrackpoint.TrackDate);
        lCard.InventoryBatteryClass = 'InventoryBattery' + lTrackpoint.BatteryLevel;
        lCard.InventorySignalClass = 'InventoryBattery' + lTrackpoint.BatteryLevel;
        lCard.ExtendedDetail = veritracks.mapping.trackpointGenerateCardDetail(lTrackpoint);
        mEnrolleesData.OffenderMapCardDirty.push(lCard);
    }
    lSort = new SortExpression();
    lSort.addDescendingColumn('SortDate');
    mEnrolleesData.OffenderMapCardDirty = lSort.sort(mEnrolleesData.OffenderMapCardDirty);

    lSelection = mEnrolleesControls.OffenderTrackpointDetailCardView.selected();
    //mEnrolleesControls.OffenderTrackpointDetailCardView.bind('databind', veritracks.mapping.visitExpandTrackpoints_OnRender, lSelection);

    lBuilder.AddNewExpressionConditional('Id', lSelection, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    
    offenderMapDisplayAllPoints(false);

};

veritracks.mapping.visitExpandTrackpoints_OnFailure = function (aParams, a, b, c) {
    "use strict";
    alert('veritracks.mapping.tripVisit_ShowPointsFailure: ' + b);
};

// expand all function not using other single expand because it would get too messy
veritracks.mapping.visitExpandAllTrackpoints = function (aCard, aStartDate, aEndDate, aTimeframe, aCallback) {
    "use strict";
    var lStartDate = aStartDate,
        lEndDate = aEndDate,
        lVisit = aCard.TrackItem.data,
        lNow = new Date(),
        lBuilder = new SumoPredicateBuilder(),
        lSecondBuilder = new SumoPredicateBuilder(),
        lSecondaryDeviceAssignment,
        lSecondaryDevice,
        lObjectType;


    if (lStartDate <= aTimeframe.startDate) {
        lStartDate = aTimeframe.startDate;
    }
    if (lEndDate > aTimeframe.endDate) {
        lEndDate = aTimeframe.endDate;
    }

    //lSort.addAscendingColumn('TrackDate');
    if (lStartDate < lNow.addDays(-2)) {
        lObjectType = gObjectList.TrackpointHistory.AssemblyQualifiedName;
    } else {
        lObjectType = gObjectList.Trackpoint.AssemblyQualifiedName;
    }

    if (!isNullOrUndefined(mEnrolleesData.OffenderSecondaryCurrentId) && mEnrolleesData.OffenderSecondaryCurrentId != mEnrolleesData.OffenderCurrentId) {
        lSecondaryDeviceAssignment = gCurrentDeviceAssignment[mEnrolleesData.OffenderSecondaryCurrentId];
        var lKey;
        for (lKey in lSecondaryDeviceAssignment) {
            if (lSecondaryDeviceAssignment.hasOwnProperty(lKey)) {
                lSecondaryDevice = lSecondaryDeviceAssignment[lKey];
            }
        }
    }


    if (!isNullOrUndefined(lSecondaryDevice)) {
        lBuilder.AddNewExpressionConditional('TrackDate', lStartDate.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('TrackDate', lEndDate.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DeviceId', lVisit.DeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', aCard.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        lSecondBuilder.AddNewExpressionConditional('TrackDate', lStartDate.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lSecondBuilder.AddNewExpressionConditional('TrackDate', lEndDate.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        lSecondBuilder.AddNewExpressionConditional('DeviceId', lSecondaryDevice.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lSecondBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderSecondaryCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

        ReadMultiple(lObjectType, lBuilder.RootExpression, 0, aSecondaryOffenderMapExpandAll_OnSuccess, null, lSecondBuilder, null, 0);
    } else {

        lBuilder.AddNewExpressionConditional('TrackDate', lStartDate.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('TrackDate', lEndDate.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DeviceId', lVisit.DeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', aCard.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());


        ReadMultiple(lObjectType, lBuilder.RootExpression, 0, aCallback, null, aCard, null, 0);
    }

    function aSecondaryOffenderMapExpandAll_OnSuccess(aParams, aData) {
        ReadMultiple(lObjectType, aParams.RootExpression, 0, aCallback, null, aData, null, 0);
    }

}
veritracks.mapping.visitExpandTrackpoints = function (aCard, aTimeframe, aCallback) {
    "use strict";
    if (!isNullOrUndefined(aCard)) {
        var lBuilder = new SumoPredicateBuilder(),
            //lSort = new SortExpression(),
            lTwoDaysAgo = new Date(),
            lVisit = aCard.TrackItem.data,
            lStartDate = null,
            lEndDate = aTimeframe.endDate,
            lNow = new Date(),
            lObjectType,
            lSpan,
            lToasterMessage;
        lTwoDaysAgo.addDays(-3);


        if (lVisit.StartDate <= aTimeframe.startDate) {
            lStartDate = aTimeframe.startDate;
        }
        else {
            lStartDate = new Date(lVisit.StartDate);
        }
        if (lVisit.EndDate > aTimeframe.endDate) {
            lEndDate = aTimeframe.endDate;
        }
        else {
            lEndDate = new Date(lVisit.EndDate);
        }
        if (lVisit.TrackPointCount >= 4000) {
            lStartDate = new Date(lEndDate).addHours(-24);
            if (lStartDate < lVisit.StartDate) {
                lStartDate = lVisit.StartDate;
            }
            if (lStartDate < aTimeframe.startDate) {
                lStartDate = aTimeframe.startDate;
            }
            lSpan = Math.ceil((lEndDate - lStartDate) / (1000 * 60 * 60));

            lToasterMessage = 'Visit contains too many points. Mapping ';
            mActivityNotification.addNotification(lToasterMessage + lSpan + ' hours ending at ' + DisplayShortDateTime(lEndDate)); // localize issue
        }
        lBuilder.AddNewExpressionConditional('TrackDate', lStartDate.toWcf(), false, mRelationalOperatorEnum.GreaterThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('TrackDate', lEndDate.toWcf(), false, mRelationalOperatorEnum.LessThanOrEqual(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('DeviceId', lVisit.DeviceId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lBuilder.AddNewExpressionConditional('EnrolleeId', aCard.EnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        //lSort.addAscendingColumn('TrackDate');
        if (lStartDate < lNow.addDays(-2)) {
            lObjectType = gObjectList.TrackpointHistory.AssemblyQualifiedName;
        } else {
            lObjectType = gObjectList.Trackpoint.AssemblyQualifiedName;
        }
        ReadMultiple(lObjectType, lBuilder.RootExpression, 0, aCallback, null, aCard, null, 0);
    }

};

veritracks.mapping.visitCollapseTrackpoints = function (aDoDisplay) {
    "use strict";
    var lDoDisplay = true;

    if (!isNullOrUndefined(aDoDisplay)) {
        lDoDisplay = aDoDisplay;
    }

    //mEnrolleesData.OffenderMapOverlayDirty = mEnrolleesData.OffenderMapOverlayClean.slice(0);
    //mEnrolleesData.OffenderMapCardDirty = mEnrolleesData.OffenderMapCardClean.slice(0);

    mEnrolleesData.OffenderMapOverlayDirty = copyArray(mEnrolleesData.OffenderMapOverlayClean);
    mEnrolleesData.OffenderMapCardDirty = copyArray(mEnrolleesData.OffenderMapCardClean);

    //    mEnrolleesData.OffenderMapCardDirty = lSort.sort(mEnrolleesData.OffenderMapCardDirty);
    //mEnrolleesControls.OffenderTrackpointDetailCardView.bind('databind', veritracks.mapping.visitExpandTrackpoints_OnRender, null);
    if (lDoDisplay) {
        offenderMapDisplayAllPoints(false);
    }
    setLoadingBarStatus('uEnrolleesTrackPointLoadingBar', 'uTrackpointDetailCardViewViewPort', false);
};
// end show visit points

veritracks.mapping.placesMarkerHoverOut = function (aSender, aMouseEvent) {
    "use strict";
    mEnrolleesControls.TimelineMap.hideInfo();
}

veritracks.mapping.placesMarkerHover = function (aSender, aMouseEvent) {
    "use strict";
    var lPoint = aSender.sumoData,
        lHtml = [],
        mMap = mEnrolleesControls.TimelineMap.getMap();

    lHtml.push('<div style="line-height:normal;"><strong> ' + lPoint.name + '</strong></br>');
    lHtml.push('<span> ' + lPoint.vicinity + ' </span></br>');
    lHtml.push('<span style="white-space:nowrap;"> ' + localizeWrapper('cTypes') + ': ' + lPoint.types.join(", ") + ' </span></div>');
    mEnrolleesControls.TimelineMap.showInfo(aSender, lHtml.join(''), lPoint.geometry.location.lat(), lPoint.geometry.location.lng());
}

veritracks.mapping.addressMarkerHoverOut = function (aSender, aMouseEvent) {
    "use strict";
    var lMap = mEnrolleesControls.EnrolleesMap;

    if (mEnrolleesControls.TimelineMap) {
        lMap = mEnrolleesControls.TimelineMap;
    }
    lMap.hideInfo();
};

veritracks.mapping.addressMarkerHover = function (aSender, aMouseEvent) {
    "use strict";
    var lData = aSender.sumoData,
     lMap = mEnrolleesControls.EnrolleesMap,
     lHtml = [];

    var lAddress = lData.Data;

    if (mEnrolleesControls.TimelineMap) {
        lMap = mEnrolleesControls.TimelineMap;
    }

    lHtml.push('<div style="line-height:normal;">');
    if (!isNullOrUndefined(lAddress.Title)) {
        lHtml.push('<span>' + localizeText('cTitle') + ': ' + lAddress.Title + '</span></br>');
    }
    lHtml.push('<span>' + localizeText('cEnrolleeAddress') + ': ' + addressFormatter(lAddress) + '</span></br>');
    if (!isNullOrUndefined(lAddress.AddressTypeId) && lAddress.AddressTypeId >= 0) {
        lHtml.push('<span>' + localizeText('cType') + ': ' + addressTypeFormatter(lAddress.AddressTypeId) + '</span>');
    }
    lHtml.push('</div>');
    lMap.showInfo(aSender, lHtml.join(''), lData.Latitude, lData.Longitude);

};


veritracks.mapping.enrolleeMarkerHoverOut = function (aSender, aMouseEvent) {
    "use strict";
    var lMap = mEnrolleesControls.EnrolleesMap;

    if (mEnrolleesControls.TimelineMap) {
        lMap = mEnrolleesControls.TimelineMap;
    }
    lMap.hideInfo();
};

veritracks.mapping.enrolleeMarkerHover = function (aSender, aMouseEvent) {
    "use strict";
    var lPoint = aSender.sumoData,
     lTimeZone = lTimeZone = getTimezone(lPoint.TimeZoneId, 'TimeZone'),
     lMap = mEnrolleesControls.EnrolleesMap,
     lHtml = [];

    if (mEnrolleesControls.TimelineMap) {
        lMap = mEnrolleesControls.TimelineMap;
    }

    function inProgress_onHover(aFormattedAddress) {

        lHtml.push('<div style="line-height:normal;"><span> ' + localizeText('cAnalysisStart') + ': ' + displayEnrolleeTimeZoneFormatted(lPoint.StartDateUTC, lTimeZone) + '</span></br>');
        lHtml.push('<span> ' + localizeText('cAnalysisEnd') + ': ' + localizeText('cEnrolleesMappingInProgress') + ' </span></br>');
        lHtml.push('<span>' + localizeText('cEnrolleesMappingTrackpointCount') + ': ' + lPoint.TrackPointCount + '</span></br>');
        lHtml.push('<span style="white-space:nowrap;"> ' + localizeText('cEnrolleeAddress') + ': ' + aFormattedAddress + ' </span></div>');
        lMap.showInfo(aSender, lHtml.join(''), lPoint.Latitude, lPoint.Longitude);

    }
    function visit_onHover(aFormattedAddress) {
        lHtml.push('<div style="line-height:normal;"><span>' + localizeText('cAnalysisStart') + ': ' + displayEnrolleeTimeZoneFormatted(lPoint.StartDateUTC, lTimeZone) + '</span></br>');
        lHtml.push('<span>'  + localizeText('cAnalysisEnd') + ': ' + displayEnrolleeTimeZoneFormatted(lPoint.EndDateUTC, lTimeZone) + '</span></br>');
        lHtml.push('<span>' + localizeText('cEnrolleesMappingTrackpointCount') + ': ' + lPoint.TrackPointCount + '</span></br>');
        lHtml.push('<span style="white-space:nowrap;"> ' + localizeText('cEnrolleeAddress') + ': ' + aFormattedAddress + ' </span></div>');
        lMap.showInfo(aSender, lHtml.join(''), lPoint.Latitude, lPoint.Longitude);
    }

    function track_onHover(aFormattedAddress) {
        var lTotalCount = mEnrolleesData.GpsCount;
        lHtml.push('<div style="line-height:normal;"><span>  ' + localizeText('cAnalysisTrackDate') + ': ' + displayEnrolleeTimeZoneFormatted(lPoint.TrackDateUTC, lTimeZone) + '</span></br>');
        if(lPoint.TrackTypeId === 1)
            lHtml.push('<span>' + localizeText('cEnrolleesMappingGPSCount') + ': ' + lPoint.Count.toString() + localizeText('cPagerOf') + lTotalCount.toString() + '</span></br>');
        else
            lHtml.push('<span>' + localizeText('cEnrolleesMappingCount') + ': ' + lPoint.Count.toString() + '</span></br>');

        lHtml.push('<span style="white-space:nowrap;"> ' + localizeText('cEnrolleeAddress') + ': ' + aFormattedAddress + ' </span></div>');
        lMap.showInfo(aSender, lHtml.join(''), lPoint.Latitude, lPoint.Longitude);
    }

    function reverseGeoCode_OnSuccess(aResult) {
        var lResult = aResult;
        if (!isNullOrUndefined(lPoint)) {
            if (!lPoint.IsCurrent) {
                if (lPoint.Type === 2) {
                    //Visit
                    visit_onHover(lResult.formated_address);

                } else if (lPoint) {
                    //Point
                    track_onHover(lResult.formated_address);
                }
            } else {
                //In Progress
                inProgress_onHover(lResult.formated_address);
            }
        }
    }

    if (!isNullOrUndefined(lPoint)) {
        lMap.geocode(lPoint.Latitude.toString() + ',' + lPoint.Longitude.toString(), reverseGeoCode_OnSuccess);
    }
};

veritracks.mapping.enrolleeMarkerClick = function (aSender, aMouseEvent) {
    "use strict";
    var lPoint = aSender.sumoData,
         mMap = mEnrolleesControls.EnrolleesMap.getMap(),
         lHtml = [];

    

    function visit_OnChange(aSender, aSelected, aParams) {
        var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem(),
            lData;

        // selected
        if (!isNullOrUndefined(lCard)) {
            lData = lCard.TrackItem.data;

            mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', visit_OnChange);
            if (!veritracks.mapping.getMapPanelDisplay('uMapDetailPanelCell')) {
                lHtml.push('<h3 class="TrackIconProperty ');
                lHtml.push(lCard.IconClass);
                lHtml.push('IconProperty">');
                lHtml.push(lCard.DisplayName);
                lHtml.push('</h3>');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(lCard.EnrolleeName);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Start: ');
                lHtml.push(DisplayShortDateTime(lData.StartDate));
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">End: ');
                lHtml.push(DisplayShortDateTime(lData.EndDate));
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(lCard.Address);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Trackpoint Count: ');
                lHtml.push(lData.TrackPointCount);
                lHtml.push('</div>');

                mEnrolleesControls.NotificationPanel.clearNotifications();
                mEnrolleesControls.NotificationPanel.addNotification(lHtml.join(''), true);
            }
            if (isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView.getPreviousSelectedKey())) {
                veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
            }
            // set zoom
            veritracks.enrollees.mapping.zoomOut(mEnrolleesControls.EnrolleesMap.getMap(), 2);
        }
        else {
            mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', visit_OnChange);
            // set previous zoom here
            mMap.setZoom(veritracks.enrollees.mapping.data.PreviousZoom);
        }
    }

    function point_OnChange(aSender, aSelected, aParams) {
        var lCard,
            lData;

        if (mStateManager.Settings()[0] === 'Offenders') {
            lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem();
        } else {
            lCard = mEnrolleesControls.VictimTrackpointDetailCardView.selectedDataItem();
        }

        // selected
        if (!isNullOrUndefined(lCard)) {
            lData = lCard.TrackItem.data;

            if (mStateManager.Settings()[0] === 'Offenders') {
                mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', point_OnChange);
            } else {
                mEnrolleesControls.VictimTrackpointDetailCardView.unbind('selectedchanged', point_OnChange);
            }

            if (!veritracks.mapping.getMapPanelDisplay('uMapDetailPanelCell')) {
                lHtml.push('<h3 class="TrackIconProperty ');
                lHtml.push(lCard.IconClass);
                lHtml.push('IconProperty">');
                lHtml.push(lCard.DisplayName);
                lHtml.push('</h3>');
                lHtml.push('<table width="100%">');

                lHtml.push('<tr>');
                lHtml.push('<td valign="top" width="50%">');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(lCard.EnrolleeName);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(DisplayShortDateTime(lData.TrackDate));
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Address: <span id="uTrackpointDetailAddress');
                lHtml.push(lCard.Id);
                lHtml.push('">');
                lHtml.push(lCard.Address);
                lHtml.push('</span></div>');
                lHtml.push('<hr/>');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(veritracks.mapping.trackpointGenerateCardEventDetail(lPoint));
                lHtml.push('</div>');

                lHtml.push('</td>');

                lHtml.push('<td valign="top" width="50%">');

                lHtml.push('<div class="NoIconProperty">Speed: ');
                lHtml.push(DisplaySpeed(lData.Speed));
                lHtml.push('</div>');
                //lHtml.push('<div class="NoIconProperty">Altitude: ');
                //lHtml.push(lData.Altitude);
                //lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Battery Voltage: ');
                lHtml.push(DisplayVolts(lData.BatteryVoltage));
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">HDOP: ');
                lHtml.push(lData.HDOP);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Satellites In View: ');
                lHtml.push(lData.SatelliteInView);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Satellites Used: ');
                lHtml.push(lData.SatelliteUsed);
                lHtml.push('</div>');
                lHtml.push('</td>');

                lHtml.push('</tr>');
                lHtml.push('</table>');

                mEnrolleesControls.NotificationPanel.clearNotifications();
                mEnrolleesControls.NotificationPanel.addNotification(lHtml.join(''), true);
            }
            if (mStateManager.Settings()[0] === 'Offenders') {
                if (isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView.getPreviousSelectedKey())) {
                    veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
                }
            } else {
                if (isNullOrUndefined(mEnrolleesControls.VictimTrackpointDetailCardView.getPreviousSelectedKey())) {
                    veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
                }
            }

            // set zoom
            veritracks.enrollees.mapping.zoomOut(mEnrolleesControls.EnrolleesMap.getMap(), 2);
        }
        else {
            if (mStateManager.Settings()[0] === 'Offenders') {
                mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', point_OnChange);
            } else {
                mEnrolleesControls.VictimTrackpointDetailCardView.unbind('selectedchanged', point_OnChange);
            }
        
            // set previous zoom level here
            mMap.setZoom(veritracks.enrollees.mapping.data.PreviousZoom);
        }
    }

    function address_OnChange(aSender, aSelected, aParams) {
        var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem(),
            lData;

        //selected
        if (!isNullOrUndefined(lCard)) {
            lData = lCard.TrackItem.data;
            mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', address_OnChange);

            if (!veritracks.mapping.getMapPanelDisplay('uMapDetailPanelCell')) {
                lHtml.push('<h3 class="TrackIconProperty ');
                lHtml.push(lCard.IconClass);
                lHtml.push('IconProperty">');
                lHtml.push(lCard.DisplayName);
                lHtml.push('</h3>');
                lHtml.push('<table width="100%">');

                lHtml.push('<tr>');
                lHtml.push('<td valign="top" width="50%">');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(lCard.EnrolleeName);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(DisplayShortDateTime(lData.TrackDate));
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Address: <span id="uTrackpointDetailAddress');
                lHtml.push(lCard.Id);
                lHtml.push('">');
                lHtml.push(lCard.Address);
                lHtml.push('</span></div>');
                //lHtml.push('<div class="NoIconProperty">');
                //lHtml.push(veritracks.mapping.trackpointGenerateCardEventDetail(lPoint));
                //lHtml.push('</div>');

                lHtml.push('</td>');



                lHtml.push('</tr>');
                lHtml.push('</table>');

                mEnrolleesControls.NotificationPanel.clearNotifications();
                mEnrolleesControls.NotificationPanel.addNotification(lHtml.join(''), true);
            }
            if (isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView.getPreviousSelectedKey())) {
                veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
            }
            // set zoom
            veritracks.enrollees.mapping.zoomOut(mEnrolleesControls.EnrolleesMap.getMap(), 2);
        }
        else {
            mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', address_OnChange);
            // set previous zoom here
            mMap.setZoom(veritracks.enrollees.mapping.data.PreviousZoom);
        }
    }

    function inProgress_OnChange(aSender, aSelected, aParams) {
        var lCard = mEnrolleesControls.OffenderTrackpointDetailCardView.selectedDataItem(),
            lData;

        // selected
        if (!isNullOrUndefined(lCard)) {
            lData = lCard.TrackItem.data;
            mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', inProgress_OnChange);

            if (!veritracks.mapping.getMapPanelDisplay('uMapDetailPanelCell')) {
                lHtml.push('<h3 class="TrackIconProperty ');
                lHtml.push(lCard.IconClass);
                lHtml.push('IconProperty">');
                lHtml.push(lCard.DisplayName);
                lHtml.push('</h3>');
                lHtml.push('<div class="NoIconProperty">');
                lHtml.push(lCard.EnrolleeName);
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Start: ');
                lHtml.push(DisplayShortDateTime(lData.StartDate));
                lHtml.push('</div>');
                lHtml.push('<div class="NoIconProperty">Trackpoint Count: ');
                lHtml.push(lData.TrackPointCount);
                lHtml.push('</div>');

                mEnrolleesControls.NotificationPanel.clearNotifications();
                mEnrolleesControls.NotificationPanel.addNotification(lHtml.join(''), true);
            }
            if (isNullOrUndefined(mEnrolleesControls.OffenderTrackpointDetailCardView.getPreviousSelectedKey())) {
                veritracks.enrollees.mapping.PreviousZoom(mEnrolleesControls.EnrolleesMap.getZoom());
            }
            // set zoom
            veritracks.enrollees.mapping.zoomOut(mEnrolleesControls.EnrolleesMap.getMap(), 2);
        }
        else {
            mEnrolleesControls.OffenderTrackpointDetailCardView.unbind('selectedchanged', inProgress_OnChange);
            // set previous zoom here
            mMap.setZoom(veritracks.enrollees.mapping.data.PreviousZoom);
        }
    }

    if (!isNullOrUndefined(lPoint)) {
        if (!lPoint.IsCurrent) {
            //Address
            if ([5,6,7,22,23,24].indexOf(lPoint.TrackTypeId) !== -1) {
                mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanged', address_OnChange);
                mEnrolleesControls.OffenderTrackpointDetailCardView.selected('a' + lPoint.Data.Id.toString());

            } else if (lPoint.Type === 2) {
                //Visit
                mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanged', visit_OnChange);
                mEnrolleesControls.OffenderTrackpointDetailCardView.selected(lPoint.cardViewPrefix + lPoint.Id.toString() + lPoint.StartDate.getTime().toString());
                
            } else if (lPoint.TrackTypeId == 4){
                 //Visit
                 mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanged', visit_OnChange);
                 mEnrolleesControls.OffenderTrackpointDetailCardView.selected(lPoint.cardViewPrefix + lPoint.Data.Id.toString() + lPoint.Data.StartDate.getTime().toString());
                 
            } else {
                //Point
                if (mStateManager.Settings()[0] === 'Offenders') {
                    mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanged', point_OnChange);
                    mEnrolleesControls.OffenderTrackpointDetailCardView.selected(lPoint.cardViewPrefix + lPoint.Id.toString());
                } else {
                    mEnrolleesControls.VictimTrackpointDetailCardView.bind('selectedchanged', point_OnChange);
                    mEnrolleesControls.VictimTrackpointDetailCardView.selected(lPoint.cardViewPrefix + lPoint.Id.toString());
                }
            }
        } else {
            //In Progress
            mEnrolleesControls.OffenderTrackpointDetailCardView.bind('selectedchanged', inProgress_OnChange);
            mEnrolleesControls.OffenderTrackpointDetailCardView.selected(lPoint.cardViewPrefix + '-1');
        }
    }
};
veritracks.mapping.enrolleeMarkerRightClick = function(aSender,aMouseEvent,type){
    // Enrollee Map Visit Rightlick veritracks.enrollees.mapping.contextMenuVisit
    var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),        
        isInformatics = false;
    if (!isNullOrUndefined(lEnrollee)) {
        isInformatics = getInformaticsEnabled(lEnrollee.OrganizationId);
 
    }
      
    if((aSender.sumoData && (typeof aSender.sumoData.AddressId === "undefined" ||  aSender.sumoData.AddressId === -1) ) || !isInformatics) {
        return;
    }
    var listMenuIndex = [0,1,2,3];
    
    if(aSender.sumoData && typeof aSender.sumoData.IconId !== "undefined" && aSender.sumoData.ZoneId > 0){
        //Mark as S.
        var aZone = getDataItem(aSender.sumoData.ZoneId,'Zones'),POI_LABEL = 1;
        var IconId = (aSender.sumoData.Association !== null && typeof aSender.sumoData.Association !== "undefined") ? IconHelper.getIconIdByName("Visit Association Unknown") : IconHelper.getIconIdByName("Visit Amber");
        var isAssociation = aSender.sumoData['Association'] !== null && typeof aSender.sumoData.Association !== "undefined";
        if(aZone !== null && aZone.Type == POI_LABEL && (IconId == aSender.sumoData.IconId || ( isAssociation && IconId == aSender.sumoData.Association.IconId))){
            listMenuIndex.push(4); // review menu array to find index
        }
    }
    veritracks.enrollees.mapping.contextMenuVisit.show(aMouseEvent,aSender,listMenuIndex);
    // if(veritracks.enrollees.mapping.contextMenuVisit && aSender.sumoData.Association !== null){
    //     veritracks.enrollees.mapping.contextMenuVisit.show(aMouseEvent,aSender);
    // }else {
    //     veritracks.enrollees.mapping.contextMenuVisit.show(aMouseEvent,aSender,[0,1]);
    // }
}
veritracks.mapping.eventMarkerClick = function (aSender, aMouseEvent) {
    "use strict";
    var lPoint = aSender.sumoData,
        lHtml = [];

    function point_OnChange(aSender, aSelected, aParams) {
        var lCard = aSender.selectedDataItem(),
            lData = lCard.TrackItem.data;

        aSender.unbind('selectedchanged', point_OnChange);

        if (!veritracks.mapping.getMapPanelDisplay('uMapDetailPanelCell')) {
            lHtml.push('<h3 class="TrackIconProperty ');
            lHtml.push(lCard.IconClass);
            lHtml.push('IconProperty">');
            lHtml.push(lCard.DisplayName);
            lHtml.push('</h3>');
            lHtml.push('<table width="100%">');

            lHtml.push('<tr>');
            lHtml.push('<td valign="top" width="50%">');
            lHtml.push('<div class="NoIconProperty">');
            lHtml.push(lCard.EnrolleeName);
            lHtml.push('</div>');
            lHtml.push('<div class="NoIconProperty">');
            lHtml.push(DisplayShortDateTime(lData.TrackDate));
            lHtml.push('</div>');
            lHtml.push('<div class="NoIconProperty">Address: ');
            lHtml.push('<span id="uTrackpointAddressDetail');
            lHtml.push(lCard.Id);
            lHtml.push('">');
            lHtml.push(lCard.Address);
            lHtml.push('</span>');
            lHtml.push('</div>');
            lHtml.push('<hr/>');
            lHtml.push('<div class="NoIconProperty">');
            lHtml.push(veritracks.mapping.trackpointGenerateCardEventDetail(lPoint));
            lHtml.push('</div>');

            lHtml.push('</td>');

            lHtml.push('<td valign="top" width="50%">');

            lHtml.push('<div class="NoIconProperty">Speed: ');
            lHtml.push(DisplaySpeed(lData.Speed));
            lHtml.push('</div>');
            //lHtml.push('<div class="NoIconProperty">Altitude: ');
            //lHtml.push(lData.Altitude);
            //lHtml.push('</div>');
            lHtml.push('<div class="NoIconProperty">Battery Voltage: ');
            lHtml.push(DisplayVolts(lData.BatteryVoltage));
            lHtml.push('</div>');
            lHtml.push('<div class="NoIconProperty">HDOP: ');
            lHtml.push(lData.HDOP);
            lHtml.push('</div>');
            lHtml.push('<div class="NoIconProperty">Satellites In View: ');
            lHtml.push(lData.SatelliteInView);
            lHtml.push('</div>');
            lHtml.push('<div class="NoIconProperty">Satellites Used: ');
            lHtml.push(lData.SatelliteUsed);
            lHtml.push('</div>');
            lHtml.push('</td>');

            lHtml.push('</tr>');
            lHtml.push('</table>');

            mEventsControls.NotificationPanel.clearNotifications();
            mEventsControls.NotificationPanel.addNotification(lHtml.join(''), true);
        }
    }


    //veritracks.mapping.setMapPanelDisplay($('#uSecondaryMapCollapsePanel'), 'uMapDetailPanelCell', true, function () {
        mEventsControls.TrackpointCardView.bind('selectedchanged', point_OnChange);
        mEventsControls.TrackpointCardView.selected(lPoint.cardViewPrefix + lPoint.Id.toString());
    //});
};

veritracks.mapping.prepareTripData = function (aTrips) {
    "use strict";

    var lKey = null,
        i = 0,
        lTrip = null,
        lResult = null,
        lTrackPoints = [];

    for (lKey in aTrips) {
        if (aTrips.hasOwnProperty(lKey)) {
            lTrip = aTrips[lKey];
            for (i = 0; i < lTrip.Trackpoints.length; i++) {
                lTrackPoints.push(lTrip.Trackpoints[i]);
            }
        }
    }
    lResult = veritracks.mapping.prepareTrackpointMarkerData(lTrackPoints);
    return lResult;
};

veritracks.mapping.prepareVisitData = function (aDataset) {
    "use strict";

    var lKey,
        lResult = [];

    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lResult.push(veritracks.mapping.prepareVisitItem(aDataset[lKey]));
        }
    }
    return lResult;
};

veritracks.mapping.readTripsVisits = function (aEnrolleeId, aIsHistoricalTrackDate , aStartDate, aEndDate, aUpdateFlag, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    return veritracks.data.controller.readTripsAndVisits(aEnrolleeId, aIsHistoricalTrackDate, aStartDate, aEndDate, aUpdateFlag, aOnSuccess, aOnFailure, aOutParams);
};

veritracks.mapping.getTrackIcons = function (aParams, aData, aOnSuccess) {
    var iconIds = [],
        getAllFlag = 1,
        lData = aData;    
    
    GetIcons([], getAllFlag, function (aParams, aIconData) {
        var lIconsData = [];

        for (var lIconKey in aIconData) {
            if (aIconData.hasOwnProperty(lIconKey)) {
                lIconsData[aIconData[lIconKey].Id] = aIconData[lIconKey];
            }
        }
        mEnrolleesIcon.icons = lIconsData;
        if (!isNullOrUndefined(aOnSuccess)) {
            aOnSuccess(aParams, lData);
        }
    });    
}

veritracks.mapping.readTrackpointsProc = function (aEnrolleeId, aIsHistoricalDate, aStartDate, aEndDate, aGetAddress, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ReadTrackpointsProc', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId,
            'aIsHistorical': aIsHistoricalDate,
            'aStartDate': aStartDate.toWcf(),
            'aEndDate': aEndDate.toWcf(),
            'aGetAddress': aGetAddress
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

veritracks.mapping.getEnrolleeAssociations = function (aEnrolleeId, aPermission, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEnrolleeAssociations', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId,
            'aPermission': aPermission
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

/** API getEnrolleeAssociationsVisit@
 * @param  {} aEnrolleeId
 * @param  {} aAddressId
 * @param  {} aStartDate
 * @param  {} aStopDate
 * @param  {} aDataAccessFlag
 * @param  {} aOnSuccess
 * @param  {} aOnFailure
 * @param  {} aOutParams
 */
veritracks.mapping.getEnrolleeAssociationsVisit = function (aEnrolleeId,aAddressId, aStartDate, aStopDate, aDataAccessFlag, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEnrolleeAssociationsVisit', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId,
            'aStartDate': aStartDate.toWcf(),
            'aStopDate': aStopDate.toWcf(),
            'aAddressId': aAddressId,
            'aDataAccessFlag': aDataAccessFlag
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};
/** API getEnrolleePriorVisit@
 * @param  {} aEnrolleeId
 * @param  {} aAddressId
 * @param  {} aStartDate
 * @param  {} aStopDate
 * @param  {} aDataAccessFlag
 * @param  {} aOnSuccess
 * @param  {} aOnFailure
 * @param  {} aOutParams
 */
veritracks.mapping.getEnrolleePriorVisit = function (aEnrolleeId,aAddressId, aStartDate, aStopDate, aDataAccessFlag, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEnrolleePriorVisit', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId,
            'aStartDate': aStartDate.toWcf(),
            'aStopDate': aStopDate.toWcf(),
            'aAddressId': aAddressId,
            'aAgentId': 0,
            'aDataAccessFlag': aDataAccessFlag,
            'aOri': gUserDetails.OrganizationIds.join(','),
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

/** API
 * @param  {} aEnrolleeId
 * @param  {} aStartDate
 * @param  {} aStopDate
 * @param  {} aAtKnownLocationFlag
 * @param  {} aOnSuccess
 * @param  {} aOnFailure
 * @param  {} aOutParams
 */
veritracks.mapping.getEnrolleeWeekAssociation = function (aEnrolleeId, aStartDate, aStopDate, aAtKnownLocationFlag, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEnrolleeWeekAssociation', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aEnrolleeId': aEnrolleeId,
            'aStartDate': aStartDate.toWcf(),
            'aStopDate': aStopDate.toWcf(),
            'aAtKnownLocation': aAtKnownLocationFlag
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

/**
 * @param  {} aEnrolleeId
 * @param  {} aAddressId
 * @param  {} aDeviceId
 * @param  {} aZoneId
 */
veritracks.mapping.setVisitUpdateType = function(aId,aEnrolleeId,aAddressId,aDeviceId,aZoneId,aOnSuccess, aOnFailure){
    "use strict";
    var aEnrolleeSafeLabel = new EnrolleeSafeLabel();
    aEnrolleeSafeLabel.Id = aId;
    aEnrolleeSafeLabel.EnrolleeId = aEnrolleeId;
    aEnrolleeSafeLabel.ZoneId = aZoneId;
    aEnrolleeSafeLabel.DeviceId = aDeviceId;
    aEnrolleeSafeLabel.AddressId = aAddressId;
    WriteSingle(aEnrolleeSafeLabel, aOnSuccess, aOnFailure, null,true);

}

veritracks.mapping.getIncidentMatches = function (aIncidentId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ReadIncidentMatch', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aIncidentId': aIncidentId
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};


veritracks.mapping.getTrackpoints = function (aRadius, aCenterLatitude, aCenterLongitude, aStartDate, aEndDate, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('TestGetTrackpoints', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aRadiusInFeet': aRadius,
            'aCenterLatitude': aCenterLatitude,
            'aCenterLongitude': aCenterLongitude,
            'aStartDate': aStartDate,
            'aEndDate': aEndDate
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

veritracks.mapping.spatialAddresses = function (aRadius, aCenterLatitude, aCenterLongitude, aOrganizations, aPermission, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ReadEnrolleeAddressSpatial', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aRadiusInFeet': aRadius,
            'aCenterLatitude': aCenterLatitude,
            'aCenterLongitude': aCenterLongitude,
            'aOrganizationList': aOrganizations,
            'aPermission': aPermission
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

veritracks.mapping.spatialEnrolleesInMGAP = function (aRadius, aCenterLatitude, aCenterLongitude, aStartDate, aEndDate, aOrganizations, aPermission, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ReadEnrolleeMGAPSpatial', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aLatitude': aCenterLatitude,
            'aLongitude': aCenterLongitude,
            'aRadiusInFeet': aRadius,
            'aStartDate': aStartDate.toWcf(),
            'aEndDate': aEndDate.toWcf(),
            'aOrganizationList': aOrganizations,
            'aPermission': aPermission
        }, aOnSuccess, aOnFailure, aOutParams);
    }
};

veritracks.mapping.setCenter = function (aMap, aLayerName, aZoneId, aCenter) {
    "use strict";
    var lShape = aMap.layerGetShape(aLayerName, aZoneId);

    lShape.setCenter(aCenter);
}

veritracks.mapping.changeColorOfShape = function (aShape, aZoneType) {
    if (!aShape) return;

    if (aZoneType === 1) { // inclusion
        lColor = '#55d400'; // green
    } else { // exclusion
        lColor = '#d40000'; // red
    }

    aShape.setOptions({ 'fillColor': lColor, 'strokeColor': lColor });
}

veritracks.mapping.changeColor = function (aData, aZoneType, aPropertyName) {
    if (!aData) return;

    if (aZoneType === 1) { // inclusion
        lColor = '#55d400'; // green
    } else { // exclusion
        lColor = '#d40000'; // red
    }

    aData[aPropertyName].fillColor = lColor;
    aData[aPropertyName].strokeColor = lColor;
}

veritracks.mapping.changeShapeColor = function (aMap, aLayerName, aZoneId, aZoneType) {
    "use strict";
    var lShape = aMap.layerGetShape(aLayerName, aZoneId),
        lColor;


    if (aZoneType === 1) { // inclusion
        lColor = '#55d400'; // green
    } else { // exclusion
        lColor = '#d40000'; // red
    }

    lShape.setOptions({ 'fillColor': lColor, 'strokeColor': lColor });
};

veritracks.mapping.resetZone = function (aMap, aLayerName, aZoneId) {
    "use strict";
    var lShape = aMap.layerGetShape(aLayerName, aZoneId),
        lCenter = null,
        lPath = [],
        lDegrees = sumo.geo.conversion.feetToDegreeLatitude(100);

    if (!isNullOrUndefined(lShape) && !isNullOrUndefined(lShape.getCenter)) {
        lCenter = lShape.getCenter();
    } else {
        lCenter = aMap.getCenter();
    }

   lPath.push(new google.maps.LatLng(lCenter.lat() + lDegrees, lCenter.lng() - lDegrees));
   lPath.push(new google.maps.LatLng(lCenter.lat() + lDegrees, lCenter.lng() + lDegrees));
   lPath.push(new google.maps.LatLng(lCenter.lat() - lDegrees, lCenter.lng() + lDegrees));
   lPath.push(new google.maps.LatLng(lCenter.lat() - lDegrees, lCenter.lng() - lDegrees));
   if (!isNullOrUndefined(lShape.setPath)) {
       lShape.setPath(lPath);
   }
   lShape.setDraggable(true);
};

veritracks.mapping.prepareZoneData = function (aDataset) {
    "use strict";
    var lKey,
        lResult = [];
    for (lKey in aDataset) {
        if (aDataset.hasOwnProperty(lKey)) {
            lResult.push(veritracks.mapping.prepareZoneItem(aDataset[lKey]));
        }
    }
    return lResult;
};

veritracks.mapping.prepareZoneItem = function (aZone) {
    "use strict";
    var lKey,
        lShapeType,
        lColor,
        lResult = {};

    // Circular = 1
    // Polygonal = 2
    if (!isNullOrUndefined(aZone)) {
        if (aZone.Shape !== 2) {
            lShapeType = 'circle';
        } else {
            lShapeType = 'polygon';
        }
        // Inclusion = 1
        // Exclusion = 2
        // VIEWONLY = 3
        if (aZone.Type === 1) {
            lColor = '#55d400'; // green
        } else if (aZone.Type === 2) {
            lColor = '#d40000'; // red
        }
        else {
            lColor = '#acacac'; // gray
        }
        lResult = {
            'type': lShapeType,
            'id': aZone.Id,
            'centerLatitude': aZone.CenterLatitude,
            'centerLongitude': aZone.CenterLongitude,
            'radius': sumo.geo.conversion.feetToMeters(aZone.Radius),
            'vertices': aZone.vertices,
            'isEditable': false,
            'fillColor': lColor,
            'fillOpacity': 0.30,
            'strokeColor': lColor,
            'strokeOpacity': 0.65,
            'strokeWeight': 2,
            'text': 'hello',
            'data': aZone
        };
    }
    return lResult;
};

veritracks.mapping.displayEnrolleeAddresses = function (aAddressList, aMap, aLayerName) {
    "use strict";

    if (!isNullOrUndefined(aAddressList)) {
        var lKey,
        lAddress,
        lAddressList = [];

        for (lKey in aAddressList) {
            if (aAddressList.hasOwnProperty(lKey)) {
                lAddress = aAddressList[lKey];
                lAddressList.push(veritracks.mapping.prepareAddressItem(lAddress));
            }
        }
        aMap.layerSetDataSource(aLayerName, lAddressList);
    }
};

// mapping collapse panels
veritracks.mapping.getMapPanelDisplay = function (aPanelId) {
    "use strict";
    var lPanel = $('#' + aPanelId);

    return lPanel.is(':visible');
};

veritracks.mapping.toggleMapPanelDisplay = function (aSender, aPanelId, aCallback) {
    "use strict";   
    var lPanel = $('#' + aPanelId),
        lCollapsed = false;

    function onComplete() {
        if (!isNullOrUndefined(aCallback)) {
            aCallback();
        }
    }

    if (lPanel.is(':hidden')) {
        lPanel.show();
        $(aSender).removeClass('Collapsed');
        lCollapsed = false;
    } else {
        lPanel.hide();
        $(aSender).addClass('Collapsed');
        lCollapsed = true;
    }
    
    if (lCollapsed) {
        if (!$(lPanel).is(":visible")) {
            setTimeout(function () {
                $(window).resize();
            }, 50);
            onComplete();
        }
    } else {
        if ($(lPanel).is(":visible")) {
            setTimeout(function () {
                $(window).resize();
            }, 50);
            onComplete();
        }
    }
};

veritracks.mapping.setMapPanelDisplay = function (aSender, aPanelId, aIsVisible, aCallback) {
    var lPanel = $('#' + aPanelId),
        lCollapsed = false;

    function onComplete() {
        if (!isNullOrUndefined(aCallback)) {
            aCallback();
        }
    }

    if (aIsVisible) {
        lPanel.show();
        $(aSender).removeClass('Collapsed');
        lCollapsed = false;
    } else {
        lPanel.hide();
        $(aSender).addClass('Collapsed');
        lCollapsed = true;
    }


    if (lCollapsed) {
        if (!$(lPanel).is(":visible")) {
            setTimeout(function () {
                $(window).resize();
            }, 50);
            onComplete();
        }
    } else {
        if ($(lPanel).is(":visible")) {
            setTimeout(function () {
                $(window).resize();
            }, 50);
            onComplete();
        }
    }
};

veritracks.mapping.calculateDistances = function (aStartLatitude, aStartLongitude, aEndLatitude, aEndLongitude) {
    var lDistance,
        lDistanceKm,
        lDistanceMiles,
        lDistanceNauticalMiles,
        lDistanceFeet,
        R = 6371,
        dLat = sumo.geo.conversion.toRadians(aEndLatitude - aStartLatitude),
        dLon = sumo.geo.conversion.toRadians(aEndLongitude - aStartLongitude),
        a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(aStartLatitude * Math.PI / 180) * Math.cos(aEndLatitude * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2),
        c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
        d = R * c;
    lDistanceKm = d;
    lDistanceNauticalMiles = sumo.geo.conversion.kilometersToNauticalMiles(lDistanceKm);
    lDistanceMiles = sumo.geo.conversion.nauticalMilesToStatuteMiles(lDistanceNauticalMiles);
    lDistanceFeet = sumo.geo.conversion.nauticalMilesToFeet(lDistanceNauticalMiles);
    if (lDistanceMiles < 1) {
        lDistance = Math.round(lDistanceFeet * 10) / 10 + 'ft';
    } else {
        lDistance = Math.round(lDistanceMiles * 10) / 10 + 'mi';
    }

    return { 'distanceInFeet': lDistanceFeet, 'distanceDisplay': lDistance, 'startPoint': { 'latitude': aStartLatitude, 'longitude': aStartLongitude }, 'endPoint': { 'latitude': aEndLatitude, 'longitude': aEndLongitude } };
};

veritracks.mapping.calculateDistancesMetric = function (aStartLatitude, aStartLongitude, aEndLatitude, aEndLongitude) {
    var lDistance,
        lDistanceKm,
        lDistanceMiles,
        lDistanceNauticalMiles,
        lDistanceFeet,
        R = 6371,
        dLat = sumo.geo.conversion.toRadians(aEndLatitude - aStartLatitude),
        dLon = sumo.geo.conversion.toRadians(aEndLongitude - aStartLongitude),
        a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(aStartLatitude * Math.PI / 180) * Math.cos(aEndLatitude * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2),
        c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
        d = R * c;
    lDistanceKm = d;
    lDistanceMeters = d * 1000;
    if (lDistanceKm < 1) {
        lDistance = Math.round(lDistanceMeters * 10) / 10 + 'm';
    } else {
        lDistance = Math.round(lDistanceKm * 10) / 10 + 'km';
    }

    return { 'distanceInMeters': lDistanceMeters, 'distanceDisplay': lDistance, 'startPoint': { 'latitude': aStartLatitude, 'longitude': aStartLongitude }, 'endPoint': { 'latitude': aEndLatitude, 'longitude': aEndLongitude } };
};

veritracks.mapping.moveZoneCenter = function (aZone, aShape, aCenterLatitude, aCenterLongitude) {
    var lLatitude = 0,
        lLongitude = 0,
        lLatitudeVariance,
        lLongitudeVariance,
        lEditItem,
        lLatitudeMultiplier,
        lLongitudeMultiplier,
        lItem,
        lItem2,
        lVertices,
        lKey,
        lVertexLatitude,
        lVertexLongitude,
        lItemDetail;

    if (aZone.Shape === 2 && (aZone.CenterLatitude === 0 || aZone.CenterLongitude === 0)) {
        lVertices = aShape.getPath().getArray();
        for (lKey in lVertices) {
            if (lVertices.hasOwnProperty(lKey)) {
                lItem = lVertices[lKey];
                lLatitude += lItem.lat();
                lLongitude += lItem.lng();
            }
        }
        aZone.CenterLatitude = (lLatitude / lVertices.length);
        aZone.CenterLongitude = (lLongitude / lVertices.length);
    }

    lLatitudeVariance = (aZone.CenterLatitude - aCenterLatitude);
    lLongitudeVariance = (aZone.CenterLongitude - aCenterLongitude);
    aZone.CenterLatitude = aCenterLatitude;
    aZone.CenterLongitude = aCenterLongitude;
    lEditItem = $.extend({}, aZone);

    if (aZone.Shape === 2) { // polygon
        // lVertices = aShape.latLngs.b[0].b;
        lVertices = aShape.getPath().getArray();
        lEditItem.vertices = [];
        lLatitudeMultiplier = (lLatitudeVariance / Math.abs(lLatitudeVariance));
        lLatitudeVariance = Math.abs(lLatitudeVariance);
        lLongitudeMultiplier = (lLongitudeVariance / Math.abs(lLongitudeVariance));
        lLongitudeVariance = Math.abs(lLongitudeVariance);
        for (lKey in lVertices) {
            if (lVertices.hasOwnProperty(lKey)) {
                lItem2 = lVertices[lKey];
                lItemDetail = {};
                lVertexLatitude = lItem2.lat();
                lVertexLongitude = lItem2.lng();                
                if (!isNaN(lLatitudeMultiplier)) {
                    lItemDetail.latitude = (lVertexLatitude - (lLatitudeVariance * lLatitudeMultiplier));
                } else {
                    lItemDetail.latitude = lVertexLatitude;
                }
                if (!isNaN(lLongitudeMultiplier)) {
                    lItemDetail.longitude = (lVertexLongitude - (lLongitudeVariance * lLongitudeMultiplier));
                } else {
                    lItemDetail.longitude = lVertexLongitude;
                }
                lEditItem.vertices.push(lItemDetail);
            }
        }
    }
    return lEditItem;
};

veritracks.mapping.renderZones = function (aMap, aLayerName, aZoneList, aCallback, aParams) {
    var lBuilder = new SumoPredicateBuilder(),
        lSort = new SortExpression(),
        lPolyZoneIds = [],
        lParams,
        lItem,
        lKey;

    function sumProperty(aList, aPropertyName) {
        var lSum = 0,
            lItem,
            lKey;

        for (lKey in aList) {
            if (aList.hasOwnProperty(lKey)) {
                lItem = aList[lKey];
                lSum += lItem[aPropertyName];
            }
        }
        return lSum;
    }

    function calculateRadius(aVertexList) {
        var lSWLat = null,
            lSWLng = null,
            lNELat = null,
            lNELng = null,
            lVertex,
            lKey,
            lDistance;

        for (lKey in aVertexList) {
            if (aVertexList.hasOwnProperty(lKey)) {
                lVertex = aVertexList[lKey];
                if (lNELat === null) {
                    lNELat = lVertex.latitude;
                    lNELng = lVertex.longitude;
                    lSWLat = lVertex.latitude;
                    lSWLng = lVertex.longitude;
                }
                if (lVertex.latitude > lNELat) {
                    lNELat = lVertex.latitude;
                }
                if (lVertex.longitude > lNELng) {
                    lNELng = lVertex.longitude;
                }
                if (lVertex.latitude < lSWLat) {
                    lSWLat = lVertex.latitude;
                }
                if (lVertex.longitude < lSWLng) {
                    lSWLng = lVertex.longitude;
                }
            }
        }

        lDistance = veritracks.mapping.calculateDistances(lNELat, lNELng, lSWLat, lSWLng);
        lDistance = lDistance.distanceInFeet;
        return lDistance / 2;
    }

    function vertices_OnLoad(aParams, aData) {
        var lVertices = {},
            lVerticesObjects = {},
            lZoneDescendant,
            lZoneList = [],
            lItem,
            lKey;

        for (lKey in aData) {
            if (aData.hasOwnProperty(lKey)) {
                lItem = aData[lKey];
                if (isNullOrUndefined(lVertices[lItem.ZoneId])) {
                    lVertices[lItem.ZoneId] = [];
                    lVerticesObjects[lItem.ZoneId] = [];
                }
                if (!lItem.IsLast) {
                    lVertices[lItem.ZoneId].push({ 'latitude': lItem.Latitude, 'longitude': lItem.Longitude });
                }
                lVerticesObjects[lItem.ZoneId].push(lItem);
            }
        }

        for (lKey in aParams.Zones) {
            if (aParams.Zones.hasOwnProperty(lKey)) {
                lItem = aParams.Zones[lKey];
                lZoneDescendant = $.extend({}, lItem);
                if (!isNullOrUndefined(lItem)) {
                    if (lItem.Shape == 2 && !isNullOrUndefined(lVertices[lItem.Id])) {
                        lZoneDescendant.vertices = lVertices[lItem.Id];
                        if (lZoneDescendant.CenterLatitude === 0) {
                            lZoneDescendant.CenterLatitude = (sumProperty(lZoneDescendant.vertices, 'latitude') / lZoneDescendant.vertices.length);
                        }
                        if (lZoneDescendant.CenterLongitude === 0) {
                            lZoneDescendant.CenterLongitude = (sumProperty(lZoneDescendant.vertices, 'longitude') / lZoneDescendant.vertices.length);
                        }
                        if (lZoneDescendant.Radius === 0) {
                            lZoneDescendant.Radius = calculateRadius(lZoneDescendant.vertices);
                        }
                    }
                    lZoneList.push(veritracks.mapping.prepareZoneItem(lZoneDescendant));
                }
            }
        }

        //aParams.Map.layerSetDataSource(aParams.LayerName, lZoneList);
        //aParams.Map.layerSetDataSource(aParams.LayerName + 'Names',
        //    veritracks.mapping.prepareEnrolleesZoneLabelOverlayData(lZoneList)
        //);
        if (!isNullOrUndefined(aParams.Callback)) {
            aParams.Callback(aParams.Params, lZoneList, lVerticesObjects);
        }
    }

    if (!isNullOrUndefined(aMap)) {
        aMap.layerSetDataSource(aLayerName, []);
        aMap.layerSetDataSource(aLayerName + 'Names', []);

        for (lKey in aZoneList) {
            if (aZoneList.hasOwnProperty(lKey)) {
                lItem = aZoneList[lKey];
                if (!isNullOrUndefined(lItem) && parseInt(lItem.Shape) === 2) {
                    lPolyZoneIds.push(lItem.Id);
                }
            }
        }

        lParams = { 'Map': aMap, 'LayerName': aLayerName, 'Zones': aZoneList, 'Callback': aCallback, 'Params': aParams };

        if (lPolyZoneIds.length > 0) {
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('ZoneId', lPolyZoneIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
            lSort.addAscendingColumn('OrderIndex');
            ReadMultiple(gObjectList.ZoneVertex.AssemblyQualifiedName, lBuilder.RootExpression, 0, vertices_OnLoad, null, lParams, lSort, 0);
        } else {
            vertices_OnLoad(lParams, []);
        }
    }
};

veritracks.mapping.editZone = function (aMap, aLayer, aZone) {
    "use strict";
    var lZoneId = aZone.Id,
        lEditShape;

    if (isNullOrUndefined(lZoneId)) {
        lZoneId = aZone.id;
    }

    lEditShape = aMap.layerGetShape(aLayer, lZoneId);

    if (!isNullOrUndefined(lEditShape)) {
        lEditShape.setEditable(true);

        if (aZone.Shape === 2) {
            lEditShape.setDraggable(true);
        }

    }
    return lEditShape;
};

//ZoneClassificationId
var ZoneIdforClassified;
veritracks.mapping.saveClassifiedZone = function (aZone, aArgs, aCallback) {
    //if ($('#uZoneDetailClassified').is(':checked')) {
   // veritracks.mapping.zoneClassifiedZone(aZone.OrganizationId, aArgs, VerifiedClassifiedId_OnSuccess);
    var lIsNew = false;
    //lIsNew = (aZone.Id === -1);
    if (aZone.Id == -1) {
        lIsNew = true;
        aZone.Id = ZoneIdforClassified;
    }
    var aOriZoneClassification = new OriZoneClassification();
    aOriZoneClassification.OrganizationId = aZone.OrganizationId;
    aOriZoneClassification.ZoneClassificationId = aArgs;
    aOriZoneClassification.ZoneId = aZone.Id;
    WriteSingle(aOriZoneClassification, OrganizationalRiskLevel_OnSuccess, OrganizationalRiskLevel_OnFailure, null, true);
    //delete aOriZoneClassification.ZoneId;

    function OrganizationalRiskLevel_OnSuccess(aParams, aData) {
       // aZone.ZoneClassificationId = aData.ZoneClassificationId;
        //aZone.Id = aData.ZoneId;
        //setDataItem(aZone.Id, 'Zones', aZone);
       // var zones = getDataItems('Zones');
        mActivityNotification.addNotification(localizeWrapper('cZoneClassifiedZoneSave') + aData.ZoneClassificationId);
        aCallback(aZone,lIsNew);
    }

    function OrganizationalRiskLevel_OnFailure(aParams, aData) {
        aZone.ZoneClassificationId = -1;
        setDataItem(aZone.Id, 'Zones', aZone);
        mActivityNotification.addNotification(localizeWrapper('cZoneClassifiedZoneFail') + aData.ZoneClassificationId);
      //  aCallback(aZone, lIsNew);
    }
};

veritracks.mapping.saveZone = function (aZone, aOriginalVertices, aShape, aCallback) {
    "use strict";
    var lIsNew = false,
        lKey,
        orgRiskLvl = null;
    if (!isNullOrUndefined(arguments[4])) {
        orgRiskLvl = arguments[4];
    }
    function onFailure(aParams, a, b, c) {
        var l = '';
    }

    function onComplete(aZone) {
        // vertex zones
        if (aZone.length > 3) {
            if (aZone[0].Id > 0) {
                mActivityNotification.addNotification(localizeWrapper('cZoneVertexZoneSave'));
            }
        } else {
            if (aZone.Id > 0) {
                mActivityNotification.addNotification(localizeWrapper('cZoneZoneSave') + aZone.Name);
            } else {
                switch(aZone.Id){
                    case -2:
                        mActivityNotification.addNotification(localizeWrapper('cPOISaveErrorAlreadyExist') + " "+ aZone.Name);
                        break;
                    default:
                        mActivityNotification.addNotification(localizeWrapper('cZoneZoneSaveError') + aZone.Name);
                        break;
                }

            }
        }
        if (!isNullOrUndefined(aCallback)) {
            aCallback(aZone, lIsNew);
        }
    }

    function globalZone_OnSuccess(aParams, aData) {
        if (!isNullOrUndefined(aData) && aData > 0) {
            mActivityNotification.addNotification(localizeWrapper('cZoneGlobalZoneSave') + aData);
        }
        if (!isNullOrUndefined(orgRiskLvl)) {
            classified_OnSave(aZone, orgRiskLvl);
        }
    }

    function vertex_OnSuccess(aParams, aData) {
        onComplete(aParams);
    }

    function zone_OnSuccess(aParams, aData) {
        var lWriteVertices = [],
            lGlobalVertexes = [],
            lEditedZoneVertex = false,
            lVertices,
            lVertex,
            lItem,
            lKey;
        if (aData.Id > 0) {

            if (isNullOrUndefined(orgRiskLvl)) {    
                aData.ZoneClassificationId = -1;
                setDataItem(aData.Id, 'Zones', aData);
            }
            else {
                aData.ZoneClassificationId = orgRiskLvl;
                setDataItem(aData.Id, 'Zones', aData);
              //  setDataItem(null, 'Zones', aData);
            }
            //if (!isNullOrUndefined(aOriginalVertices)) {
            //    for (lKey in aOriginalVertices) {
            //        if (aOriginalVertices.hasOwnProperty(lKey)) {
            //            lVertex = aOriginalVertices[lKey];
            //            lVertex.IsActive = false;
            //            lVertex.TransactionId = moment().format("YYYYMMDDHHmmss");
            //            lVertex.IsLast = false;
            //            lWriteVertices.push(lVertex);
            //        }
            //    }

            //    if (aOriginalVertices.length > 0) {
            //        lEditedZoneVertex = true;
            //    } else {
            //        lEditedZoneVertex = false;
            //    }
            //}
            //if (aData.Shape === 2 && aData.IsActive) {
            //    lVertices = aShape.getPath();
            //    if (!isNullOrUndefined(lVertices)) {
            //        for (lKey = 0; lKey < lVertices.length; lKey++) {
            //            lItem = lVertices.getAt(lKey);
            //            lVertex = new ZoneVertex(aData.Id, lItem.lat(), lItem.lng(), lKey + 1);
            //            lWriteVertices.push(lVertex);
            //            lGlobalVertexes.push(lVertex);
            //        }
            //        if (!lEditedZoneVertex) {
            //            lItem = lVertices.getAt(0);
            //            lVertex = new ZoneVertex(aData.Id, lItem.lat(), lItem.lng(), lVertices.length + 1);
            //            lVertex.IsLast = true;
            //            lWriteVertices.push(lVertex);
            //            lGlobalVertexes.push(lVertex);
            //            //TODO: remove lGlobalVertex reference. not needed anymore
            //        }
            //    }
            //}
            // if (isNullOrUndefined(orgRiskLvl)) {
            //classified_OnSave(aData, orgRiskLvl);
            //globalZone_OnSuccess(null, []);
            onComplete(aData);
           // }
            //if (lWriteVertices.length > 0) {
            //    WriteMultiple(lWriteVertices, vertex_OnSuccess, onFailure, aData, true);
            //} else {
            //    if (isNullOrUndefined(orgRiskLvl)) {
            //        onComplete(aData);
            //    }
            //}
            //ZoneIdforClassified = aData.Id;
            //WriteGlobalZonePQ(aData, globalZone_OnSuccess, onFailure);
        } else {
            onComplete(aData, lIsNew);
        }
    }

    function sequenceReader_OnSuccess(aParams, aData) {
        aZone.GlobalZoneId = aData.Id;
        WriteSingle(aZone, zone_OnSuccess, onFailure, null, true);
    }

    function classified_OnSave(aParams, aData)
    {
        veritracks.mapping.saveClassifiedZone(aParams, aData, aCallback);
    }
    function init() {
       
        var lZoneIndexList = [];
        var lZoneVertextLatList = [];
        var lZoneVertextLngList = [];
        var lZoneVertextActive = [];
        var lZoneIsLastList = [];
        var lZoneVertextIds = [];
        var lVertices = [];
        var lItem = {};
        var lVertex = {};
        var lEditedZoneVertex = false;
        if (!isNullOrUndefined(aShape)) {
            aShape.setEditable(false);
        }
        lIsNew = (aZone.Id === -1);
        aZone.IsVisible = (aZone.IsVisible || aZone.IsVisible === 'true');
        //remove all white spaces
        aZone.Name = $.trim(aZone.Name);
        aZone.TransactionId = moment().format("YYYYMMDDHHmmss");
        if (!isNullOrUndefined(aOriginalVertices)) {
            if (aOriginalVertices.length > 0) {
                lEditedZoneVertex = true;
            } else {
                lEditedZoneVertex = false;
            }
        }

        if (aZone.Shape == 2 && aZone.IsActive) {
            lVertices = aShape.getPath();
            if (!isNullOrUndefined(lVertices)) {
                for (lKey = 0; lKey < lVertices.length; lKey++) {
                    lItem = lVertices.getAt(lKey);
                    lVertex = new ZoneVertex(-1, lItem.lat(), lItem.lng(), lKey + 1);
                    lZoneIndexList.push(lVertex.OrderIndex);
                    lZoneVertextLatList.push(lVertex.Latitude);
                    lZoneVertextLngList.push(lVertex.Longitude);
                    lZoneVertextActive.push(lVertex.IsActive);
                    lZoneIsLastList.push(false);
                    lZoneVertextIds.push(lVertex.Id);
                }
                if (!lEditedZoneVertex) {
                    lZoneIsLastList[0] = true;
                    //TODO: remove lGlobalVertex reference. not needed anymore
                }
                aZone.OrderIndex = lZoneIndexList.join(",");
                aZone.VertexLatitude = lZoneVertextLatList.join(",");
                aZone.VertexLongitude = lZoneVertextLngList.join(",");
                aZone.IsVertexActive = lZoneVertextActive.join(",");
                aZone.IsLast = lZoneIsLastList.join(",");
                aZone.VertexId = lZoneVertextIds.join(",")
            }
        }
        WriteSingle(aZone, zone_OnSuccess, onFailure, null, true);
    }

    init();

};

//veritracks.mapping.setGeocodeButtonStatus = function (aMapData, aIsActive) {
//    if (!aIsActive) {
//        aMapData.DoGeocode = false;
//        $('#uGeocodeToolBarButton').removeClass('Selected');
//    } else {
//        aMapData.DoGeocode = true;
//        $('#uGeocodeToolBarButton').addClass('Selected');
//    }
//};

//veritracks.mapping.setGeocodeButtonStatus = function (aMapData, aIsActive) {

//}
veritracks.mapping.zoneRiskLevel= function (lOrganizationId, aClasifiedId, aCallback) {
    "use strict"
    var lBuilder = new SumoPredicateBuilder(),
        lClassifiedId = aClasifiedId;

    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ZoneClassificationId', lClassifiedId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OrganizationRiskLevel.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, null, {}, null, 0, false);

};

veritracks.mapping.zoneClassifiedZone = function (lOrganizationId, aClasifiedId, aCallback) {
    "use strict"
    var lBuilder = new SumoPredicateBuilder(),
        lClassifiedId = aClasifiedId,
        lZoneCheck;

    if (lClassifiedId == -1) {
        lZoneCheck = mRelationalOperatorEnum.NotEqual();
    }
    else {
        lZoneCheck = mRelationalOperatorEnum.Equal();
    }

    lBuilder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    lBuilder.AddNewExpressionConditional('ZoneClassificationId', lClassifiedId, false, lZoneCheck, mLogicalOperatorEnum.And());

    ReadMultiple(gObjectList.OriZoneClassification.AssemblyQualifiedName, lBuilder.RootExpression, 0, aCallback, null, {}, null, 0, false);

};

veritracks.mapping.reverseGeoCode = function(map, lat, lng, aCallback){ 
    "use strict";
    map.geocode(lat.toString() + ',' + lng.toString(), aCallback);

};

veritracks.mapping.localityTypeMatch = function (aType) {
    "use strict";
    var lMatch = false;

    if (aType === 'street_address' || aType === 'locality' || aType === 'premise' || aType === 'courthouse' || aType === 'point_of_interest' || aType === 'establishment' || aType === 'route' || aType === 'intersection') {
	    lMatch = true;
    }

    return lMatch;
}